<template>
    <div>
        <Fieldset :legend="$t('searchHeader')" :toggleable="true">
            <div class="p-fluid p-mt-2 p-ml-3 p-mr-3 p-mb-2" @keyup.enter="saveData_Modal('search')">
                <div class="p-formgrid p-grid p-col p-mt-1">
                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="provinceOptions">{{ $t('province') }}</label>
                        <Dropdown
                            v-model="selectedProvince"
                            :options="provinceOptions"
                            optionLabel="province_name"
                            :filter="true"
                            :placeholder="$t('placeholderSelectBox')"
                            :showClear="true"
                            :clearFilterDropdown="dropdownClearFilerValue"
                        >
                            <template #value="provinceOptions">
                                <div v-if="provinceOptions.value">
                                    <div>{{ provinceOptions.value.province_name }}</div>
                                </div>
                            </template>
                            <template #option="provinceOptions">
                                <div>{{ provinceOptions.option.province_name }}</div>
                            </template>
                        </Dropdown>
                    </div>

                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="amphurOptions">{{ $t('amphur') }}</label>
                        <Dropdown
                            :disabled="isDisabledAmphur == 1"
                            v-model="selectedAmphur"
                            :options="amphurOptions"
                            optionLabel="amphur_name"
                            :filter="true"
                            :placeholder="$t('placeholderSelectBox')"
                            :showClear="true"
                            :clearFilterDropdown="dropdownClearFilerValue"
                        >
                            <template #value="amphurOptions">
                                <div v-if="amphurOptions.value">
                                    <div>{{ amphurOptions.value.amphur_name }}</div>
                                </div>
                            </template>
                            <template #option="amphurOptions">
                                <div>{{ amphurOptions.option.amphur_name }}</div>
                            </template>
                        </Dropdown>
                    </div>

                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="tambonOptions">{{ $t('tambon') }}</label>
                        <Dropdown
                            :disabled="isDisabledTambon == 1"
                            v-model="selectedTambon"
                            :options="tambonOptions"
                            optionLabel="tambon_name"
                            :filter="true"
                            :placeholder="$t('placeholderSelectBox')"
                            :showClear="true"
                            :clearFilterDropdown="dropdownClearFilerValue"
                        >
                            <template #value="tambonOptions">
                                <div v-if="tambonOptions.value">
                                    <div>{{ tambonOptions.value.tambon_name }}</div>
                                </div>
                            </template>
                            <template #option="tambonOptions">
                                <div>{{ tambonOptions.option.tambon_name }}</div>
                            </template>
                        </Dropdown>
                    </div>

                    <!-- Doe เพิ่ม สถานีดับเพลิงและกู้ภัย -->
                    <!-- <div class="p-field p-col-12 p-lg-3 p-mt-2" 
               v-if="!selectedProvince &&
                     !selectedAmphur &&
                     !selectedTambon">
            <label for="FireStationOptions">{{ 'สถานีดับเพลิงและกู้ภัย' }} </label>
            <Dropdown
              
              v-model="FireStationSelected"
              :options="FireStationOptions"
              optionLabel="fs_tname"
              :filter="true"
              :placeholder="$t('placeholderSelectBox')"
              :showClear="true"
              :clearFilterDropdown="dropdownClearFilerValue"
            >
              <template #value="FireStationOptions">
                <div v-if="FireStationOptions.value">
                  <div>{{ FireStationOptions.value.fs_tname }}</div>
                </div>
              </template>
              <template #option="FireStationOptions">
                <div>{{ FireStationOptions.option.fs_tname }}</div>
              </template>
            </Dropdown>
          </div> -->

                    <!-- <div class="p-field p-col-12 p-lg-3 p-mt-2" v-else> -->
                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="FireStationOptions">{{ 'สถานีดับเพลิงและกู้ภัย' }} </label>
                        <Dropdown
                            v-model="FireStationSelected"
                            :options="FireStationOptions_AT"
                            optionLabel="fs_tname"
                            :filter="true"
                            :placeholder="$t('placeholderSelectBox')"
                            :showClear="true"
                            :clearFilterDropdown="dropdownClearFilerValue"
                        >
                            <template #value="FireStationOptions_AT">
                                <div v-if="FireStationOptions_AT.value">
                                    <div>{{ FireStationOptions_AT.value.fs_tname }}</div>
                                </div>
                                <span v-else>
                                    {{ FireStationOptions_AT.placeholder }}
                                </span>
                            </template>
                            <template #option="FireStationOptions_AT">
                                <div>{{ FireStationOptions_AT.option.fs_tname }}</div>
                            </template>
                        </Dropdown>
                    </div>
                </div>

                <div class="p-formgrid p-grid p-col p-mt-1">
                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="house_no">{{ 'เลขที่' }}</label>
                        <InputText
                            id="house_no"
                            type="text"
                            v-model="house_no"
                            ref="TextBox_1_search"
                            @keyup.left="moveFocus($event, 'TextBox_5_search', 'Button')"
                            @keyup.right="moveFocus($event, 'TextBox_2_search', 'Input')"
                        />
                    </div>

                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="icommu_soi_name">{{ 'ซอย/ตรอก' }}</label>
                        <InputText
                            id="icommu_soi_name"
                            type="text"
                            v-model="soi_name"
                            ref="TextBox_2_search"
                            @keyup.left="moveFocus($event, 'TextBox_1_search', 'Input')"
                            @keyup.right="moveFocus($event, 'TextBox_3_search', 'Input')"
                        />
                    </div>

                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="icommu_road_name">{{ 'ถนน' }}</label>
                        <InputText
                            id="icommu_road_name"
                            type="text"
                            v-model="road_name"
                            ref="TextBox_3_search"
                            @keyup.left="moveFocus($event, 'TextBox_2_search', 'Input')"
                            @keyup.right="moveFocus($event, 'TextBox_4_search', 'Button')"
                        />
                    </div>

                    <div class="p-field p-col p-lg-3 p-mt-2">
                        <div class="p-formgrid p-grid p-jc-end p-mt-5">
                            <!-- Doe โหลด โทรศัพท์ -->
                            <Button
                                v-if="window.width <= 430"
                                @click="MobileClearSearchField()"
                                :label="$t('clearBtn')"
                                class="p-button-clear p-ml-3 p-mr-3"
                                ref="TextBox_4_search"
                                @keyup.left="moveFocus($event, 'TextBox_3_search', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_5_search', 'Button')"
                            />
                            <Button
                                v-else
                                @click="clearSearchField()"
                                :label="$t('clearBtn')"
                                class="p-button-clear p-ml-3 p-mr-3"
                                ref="TextBox_4_search"
                                @keyup.left="moveFocus($event, 'TextBox_3_search', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_5_search', 'Button')"
                            />
                            <!-- Doe โหลด โทรศัพท์ -->
                            <Button
                                @click="searchFireStation()"
                                :label="$t('searchBtn')"
                                class="p-button-info"
                                ref="TextBox_5_search"
                                @keyup.left="moveFocus($event, 'TextBox_4_search', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_1_search', 'Input')"
                            />
                        </div>
                    </div>
                </div>
                <div class="p-formgrid p-grid p-col p-mt-1">
                    <text-footer :data="Data_text_Footer" :checkShow="text_Footer" :countItem="FireStation_Table.length.toLocaleString('en-US')" />
                </div>
            </div>
        </Fieldset>

        <div class="card p-fluid p-mt-2">
            <!-- Doe : เพิ่ม ลำดับ 1/4   sortField="index" :sortOrder="1" -->
            <DataTable
                :value="columns_disabled ? FireStation_Table : []"
                scrollHeight="500px"
                :paginator="true"
                :rows="10"
                :sortOrder="1"
                sortField="index"
                dataKey="fs_id"
                ref="dt"
                :exportFilename="`ข้อมูลสถานีดับเพลิงและกู้ภัย-${date}`"
                :rowHover="true"
                :selection.sync="selectedFireHydrant"
                :filters="filters"
                :loading="loading"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
            >
                <!-- Doe : เพิ่ม ลำดับ 1/4   sortField="index" :sortOrder="1" จบ-->
                <template #header>
                    <div class="p-grid p-col">
                        <div class="table-header" id="Create" style="padding: 7px" v-if="checkAdd_data != 'false'">
                            <Button @click="FireStationModal = true" :label="$t('addBtn')" class="p-button-success" />
                        </div>

                        <!-- Doe : PDF 1/3 -->
                        <div class="table-header" style="padding: 7px" id="EX">
                            <Button @click="exportCSV()" :label="$t('exportBtn')" style="background-color: green" />
                        </div>
                        <div class="table-header" style="padding: 7px" id="PDF">
                            <SplitButton
                                label="ส่งออก PDF"
                                :model="items"
                                class="p-button-raised p-button-danger"
                                style="background-color: #f33737"
                            ></SplitButton>
                        </div>
                        <!-- Doe : PDF 1/3 จบ -->

                        <!-- Doe PDF เลือกได้  1/5   -->
                        <div class="table-header" id="TABLE_EDIT" style="padding: 7px">
                            <Button
                                @click="EditPDF()"
                                icon="pi pi-cog"
                                :label="'ตั้งค่า'"
                                style="background-color: #0288d1; border: 1px solid #0288d1"
                            />
                        </div>

                        <div class="table-header" id="TABLE_EDIT" style="padding: 7px" v-if="selectedFireHydrant && selectedFireHydrant.length > 0">
                            <Button
                                @click="updateDates()"
                                icon="pi pi-cog"
                                :label="'ปรับปรุงข้อมูล'"
                                style="background-color: #fab12f; border: 1px solid #fab12f"
                            />
                        </div>

                        <!-- Doe PDF เลือกได้  1/5 จบ  -->

                        <div class="table-header p-col-12 p-lg-3" id="Search" style="margin-left: auto">
                            <!-- <span class="p-input-icon-left">
                  <i class="pi pi-search" /><InputText
                    v-model="filters['global']"
                    :placeholder="$t('searchHeader')"
                  />
                </span> -->

                            <!-- Doe ค้นหา  1/5 -->
                            <span class="p-input-icon-left" v-if="columns_disabled">
                                <i class="pi pi-search" />
                                <InputText v-model="filter" @input="search" :placeholder="$t('searchHeader')" ref="searchInput" />
                            </span>
                            <span class="p-input-icon-left" v-else>
                                <i class="pi pi-search" />
                                <InputText disabled v-model="filter" :placeholder="$t('searchHeader')" />
                            </span>

                            <!-- Doe ค้นหา  1/5 จบ-->
                        </div>
                    </div>
                </template>

                <Column :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')">
                    <template #header>
                        <div v-if="columns_disabled">
                            <input
                                style="width: 20px; height: 20px"
                                type="checkbox"
                                :checked="selectedFireHydrant.length === FireStation_Table.length"
                                @change="onSelectAll($event.target.checked)"
                            />
                        </div>
                    </template>
                    <template #body="slotProps">
                        <div class="table_row" v-if="columns_disabled" style="text-align: center">
                            <input
                                style="width: 20px; height: 20px"
                                type="checkbox"
                                :checked="selectedFireHydrant.some((item) => item.fs_id === slotProps.data.fs_id)"
                                @change="onSelectRow(slotProps.data, $event.target.checked)"
                            />
                        </div>
                    </template>
                </Column>

                <template #empty>{{ $t('TableEmpty') }}</template>
                <div v-if="columns_index == true">
                    <!--Doe : เพิ่มลำดับ 2/4-->
                    <Column field="index" :header="'ลำดับ'" :sortable="true" :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_index == true">
                                {{ dataTable.data.index }}
                            </div>
                        </template>
                    </Column>
                    <!--Doe : เพิ่มลำดับ 2/4 จบ-->
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_fs_tname == true">
                    <Column
                        field="fs_tname"
                        :header="'สถานีดับเพลิงและกู้ภัย'"
                        :sortable="true"
                        :headerStyle="tableColSticky('20rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_fs_tname == true">
                                {{ dataTable.data.fs_tname }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>
                <!-- <Column
            field="event_detail"
            :header="'ที่อยู่'"
            :sortable="true"
            headerStyle="width: 20rem"
          >
            <template #body="dataTable">
              
              {{ dataTable.data.event_detail }}
            </template>
          </Column> -->

                <div v-if="columns_house_no == true">
                    <Column field="house_no" :header="'เลขที่'" :sortable="true" :headerStyle="tableColSticky('10rem', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_house_no == true">
                                {{ dataTable.data.house_no }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_soi_name == true">
                    <Column field="soi_name" :header="'ซอย/ตรอก'" :sortable="true" :headerStyle="tableColSticky('22rem', '', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div v-if="columns_soi_name == true">
                                {{
                                    dataTable.data.soi_name == 'null' || dataTable.data.soi_name == '' || dataTable.data.soi_name == null
                                        ? '-'
                                        : dataTable.data.soi_name
                                }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_road_name == true">
                    <Column field="road_name" :header="'ถนน'" :sortable="true" :headerStyle="tableColSticky('22rem', '', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div v-if="columns_road_name == true">
                                {{ dataTable.data.road_name == 'null' || dataTable.data.road_name == '' ? '-' : dataTable.data.road_name }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_tambon_name == true">
                    <Column
                        field="tambon_name"
                        :header="'แขวง/ตำบล'"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', 'center', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <!-- {{ dataTable.data.tambon_name }} -->
                            <div class="table_row" v-if="columns_tambon_name == true">
                                {{
                                    dataTable.data.tambon_name == 'null' || dataTable.data.tambon_name == null || dataTable.data.tambon_name == ''
                                        ? '-'
                                        : dataTable.data.tambon_name
                                }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_amphur_name == true">
                    <Column
                        field="amphur_name"
                        :header="'เขต/อำเภอ'"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', 'center', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <!-- {{ dataTable.data.amphur_name }} -->
                            <div class="table_row" v-if="columns_amphur_name == true">
                                {{
                                    dataTable.data.amphur_name == 'null' || dataTable.data.amphur_name == null || dataTable.data.amphur_name == ''
                                        ? '-'
                                        : dataTable.data.amphur_name
                                }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_province_name == true">
                    <Column
                        field="province_name"
                        :header="'จังหวัด'"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', 'center', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_province_name == true">
                                {{ dataTable.data.province_name }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_event_lat == true">
                    <Column field="event_lat" :header="`ละติจูด`" :sortable="true" :headerStyle="tableColSticky('10rem', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_event_lat == true">
                                {{ parseFloat(dataTable.data.event_lat).toFixed(6) }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_event_lon == true">
                    <Column field="event_lon" :header="`ลองจิจูด`" :sortable="true" :headerStyle="tableColSticky('10rem', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_event_lon == true">
                                {{ parseFloat(dataTable.data.event_lon).toFixed(6) }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_date_create == true">
                    <Column
                        field="date_create_ddmmyy"
                        :header="'วันที่สร้างข้อมูล'"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_date_create == true">
                                {{ dataTable.data.date_create_ddmmyy }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_date_update == true">
                    <Column
                        field="date_update_ddmmyy"
                        :header="'วันที่ปรับปรุงข้อมูล'"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_date_update == true">
                                {{ dataTable.data.date_update_ddmmyy }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div
                    v-if="
                        columns_event_lon ||
                        columns_index ||
                        columns_fs_tname ||
                        columns_house_no ||
                        columns_soi_name ||
                        columns_road_name ||
                        columns_tambon_name ||
                        columns_amphur_name ||
                        columns_province_name ||
                        columns_event_lat ||
                        columns_date_create ||
                        columns_date_update
                    "
                >
                    <Column
                        :header="$t('controlTable')"
                        :headerStyle="table_headerStyle"
                        :bodyStyle="table_bodyStyle"
                        v-if="checkEdit_data != 'false' || checkDelete_data != 'false'"
                    >
                        <template #body="dataTable">
                            <div class="p-formgrid col_manege" v-if="checkNotAdminPermission(dataTable.data.user_organize)">
                                <div :class="table_BOXmanege" v-if="checkEdit_data != 'false'">
                                    <Button
                                        @click="
                                            FireStationModal = true;
                                            editData(dataTable.data.fs_id);
                                            temp = dataTable.data.fs_id;
                                        "
                                        icon="pi pi-pencil"
                                        :label="table_editBTN"
                                        class="p-button-rounded p-button-warning"
                                    />
                                </div>
                                <div :class="table_BOXmanege" v-if="checkDelete_data != 'false'">
                                    <Button
                                        @click="
                                            // displayConfirmation = true;
                                            temp = dataTable.data.fs_id;

                                            alertDisplay(temp);
                                        "
                                        icon="pi pi-trash"
                                        :label="table_deleteBTN"
                                        class="p-button-rounded p-button-danger"
                                    />
                                </div>
                            </div>
                            <div v-else>
                                {{ 'ไม่มีสิทธิ์จัดการข้อมูลนี้' }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"></Column>
                </div>
            </DataTable>
        </div>

        <!-- Manage data -->
        <Dialog
            :modal="true"
            :visible.sync="FireStationModal"
            :style="{ width: '80%' }"
            :header="header_FireStation"
            id="dialog_ifh"
            :closable="loadingCreate ? false : true"
            :contentStyle="{}"
        >
            <div class="confirmation-content" @keyup.enter="saveData_Modal('Modal_Main')">
                <!-- โหลดเพิ่มแก้ไข 1/8-->
                <div class="From_Loading" v-if="loadingCreate" style="top: 38%">
                    <ProgressSpinner style="width: 120px; height: 120px; color: red" strokeWidth="5" animationDuration="1s" />
                    <div class="waveTextAnimated">
                        <span>กำ</span>
                        <span>ลัง</span>
                        <span>บัน</span>
                        <span>ทึก</span>
                        <span>ข้อ</span>
                        <span>มูล</span>
                        <!-- กำลังบันทึกข้อมูล -->
                    </div>
                </div>
                <!-- โหลดเพิ่มแก้ไข 1/8 จบ-->
                <label>{{ $t('ira_modal_subtitle') }}</label>
                <div class="p-fluid p-mt-5">
                    <!-- <div class="p-formgrid p-grid"> -->
                    <div class="p-formgrid p-grid" style="display: flex">
                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="ifs_FireStation">{{ 'สถานีดับเพลิงและกู้ภัย' }} <span class="required-input">*</span></label>
                            <InputText
                                id="ifs_FireStation"
                                type="text"
                                v-model="ifs_FireStation"
                                required="true"
                                autofocus
                                :class="{
                                    'p-invalid': error_ifs_FireStation && !ifs_FireStation
                                }"
                                ref="TextBox_1"
                                @keyup.left="moveFocus($event, 'TextBox_9', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_5', 'Input')"
                            />
                            <small class="p-invalid" v-if="error_ifs_FireStation && !ifs_FireStation">{{ 'กรุณาระบุสถานีดับเพลิงและกู้ภัย' }}</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="ifs_house_no"
                                >{{ 'เลขที่' }}
                                <span class="required-input"></span>
                            </label>
                            <InputText
                                id="ifs_house_no"
                                type="text"
                                v-model="ifs_house_no"
                                required="true"
                                ref="TextBox_2"
                                @keyup.left="moveFocus($event, 'TextBox_1', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_3', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_6', 'Input')"
                            />
                        </div>

                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="icommu_soi_name"
                                >{{ 'ซอย/ตรอก' }}
                                <span class="required-input"></span>
                            </label>
                            <InputText
                                id="icommu_soi_name"
                                type="text"
                                v-model="icommu_soi_name"
                                required="true"
                                ref="TextBox_3"
                                @keyup.left="moveFocus($event, 'TextBox_2', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_4', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_6', 'Input')"
                            />
                        </div>

                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="icommu_road_name"
                                >{{ 'ถนน' }}
                                <span class="required-input"></span>
                            </label>
                            <InputText
                                id="icommu_road_name"
                                type="text"
                                v-model="icommu_road_name"
                                required="true"
                                ref="TextBox_4"
                                @keyup.left="moveFocus($event, 'TextBox_3', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_5', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_7', 'Button')"
                            />
                        </div>
                    </div>

                    <!-- Doe เพิ่มหมุด map V.2 1/9  @input="inputMap_PAT_latlon" -->
                    <div class="p-formgrid p-grid">
                        <div class="p-field p-col-12 p-lg-4 p-mt-2">
                            <label for="provinceOptions">{{ $t('province') }} <span class="required-input"> *</span></label>
                            <Dropdown
                                v-model="ifh_selectedProvince"
                                @input="inputMap_PAT_latlon"
                                :options="provinceOptions"
                                @change="someHandler('ch-province')"
                                optionLabel="province_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :class="{
                                    'p-invalid': error_ifh_selectedProvince && !ifh_selectedProvince
                                }"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="provinceOptions">
                                    <div v-if="provinceOptions.value">
                                        <div>{{ provinceOptions.value.province_name }}</div>
                                    </div>
                                </template>
                                <template #option="provinceOptions">
                                    <div>{{ provinceOptions.option.province_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_ifh_selectedProvince && !ifh_selectedProvince">{{ 'กรุณาระบุจังหวัด' }}</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-4 p-mt-2">
                            <label for="amphurOptions">{{ $t('amphur') }} <span class="required-input"> *</span></label>
                            <Dropdown
                                :disabled="ira_isDisabledAmphur == 1"
                                v-model="ira_selectedAmphur"
                                @input="inputMap_PAT_latlon"
                                @change="someHandler('ch-amphur')"
                                :options="amphurOptions"
                                optionLabel="amphur_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :class="{
                                    'p-invalid': error_ira_selectedAmphur && !ira_selectedAmphur
                                }"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="amphurOptions">
                                    <div v-if="amphurOptions.value">
                                        <div>{{ amphurOptions.value.amphur_name }}</div>
                                    </div>
                                </template>
                                <template #option="amphurOptions">
                                    <div>{{ amphurOptions.option.amphur_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_ira_selectedAmphur && !ira_selectedAmphur">{{ 'กรุณาระบุเขต/อำเภอ' }}</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-4 p-mt-2">
                            <label for="tambonOptions">{{ $t('tambon') }} <span class="required-input"> *</span></label>
                            <Dropdown
                                :disabled="ira_isDisabledTambon == 1"
                                v-model="ira_selectedTambon"
                                @input="inputMap_PAT_latlon"
                                :options="tambonOptions"
                                optionLabel="tambon_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :class="{
                                    'p-invalid': error_ira_selectedTambon && !ira_selectedTambon
                                }"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="tambonOptions">
                                    <div v-if="tambonOptions.value">
                                        <div>{{ tambonOptions.value.tambon_name }}</div>
                                    </div>
                                </template>
                                <template #option="tambonOptions">
                                    <div>{{ tambonOptions.option.tambon_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_ira_selectedTambon && !ira_selectedTambon">{{ 'กรุณาระบุแขวง/ตำบล' }}</small>
                        </div>
                        <!-- Doe เพิ่มหมุด map V.2 1/9  @input="inputMap_PAT_latlon" จบ-->

                        <!-- Doe เพิ่ม สถานีดับเพลิงและกู้ภัย -->
                    </div>

                    <!-- <div class="p-formgrid p-grid" style="display: flex;">

                <div class="p-field p-col-12 p-lg-12 p-mt-2">
                  <label for="ifs_event_detail"
                    >{{ 'ที่อยู่' }}
                    <span class="required-input"></span>
                    </label
                  >
                  <InputText
                    id="ifs_event_detail"
                    type="text"
                    v-model="ifs_event_detail"
                    required="true"
                    autofocus
                    
                  />
                </div>
  
            </div> -->

                    <!-- Doe เพิ่มหมุด map V.2 2/9  @input="inputMap_latlon" -->
                    <div class="p-formgrid p-grid p-mt-3">
                        <div class="p-field p-col-12 p-lg-4">
                            <label for="ifh_lat">{{ $t('lat') }}<span class="required-input"> *</span></label>
                            <InputText
                                id="ifh_lat"
                                type="text"
                                v-model="ifh_lat"
                                autofocus
                                @input="inputMap_latlon"
                                :class="{
                                    'p-invalid': error_ifh_lat && !ifh_lat
                                }"
                                ref="TextBox_5"
                                @keyup.left="moveFocus($event, 'TextBox_4', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_6', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_1', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_8', 'Button')"
                            />
                            <small class="p-invalid" v-if="error_ifh_lat && !ifh_lat">{{ 'กรุณาระบุ ค่าละติจูด' }}</small>
                        </div>
                        <div class="p-field p-col-12 p-lg-4">
                            <label for="ifh_lon">{{ $t('lon') }}<span class="required-input"> *</span></label>
                            <InputText
                                id="ifh_lon"
                                type="text"
                                v-model="ifh_lon"
                                @input="inputMap_latlon"
                                :class="{
                                    'p-invalid': error_ifh_lon && !ifh_lon
                                }"
                                ref="TextBox_6"
                                @keyup.left="moveFocus($event, 'TextBox_5', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_7', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_2', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_8', 'Button')"
                            /><small class="p-invalid" v-if="error_ifh_lon && !ifh_lon">{{ 'กรุณาระบุ ค่าลองจิจูด' }}</small>
                        </div>
                        <!-- Doe เพิ่มหมุด map V.2 2/9  @input="inputMap_latlon" จบ-->

                        <!-- Doe:  เพิ่ม มุดmap 1/4 -->
                        <div class="p-field p-col-12 p-lg-4 p-mt-5">
                            <Button
                                @click="
                                    displayMap = true;
                                    sendM(ifh_lat, ifh_lon);
                                    sendM_PAT(ira_selectedTambon, ira_selectedAmphur, ifh_selectedProvince, ifh_FireStationSelected);
                                "
                                icon="pi pi-map-marker"
                                :label="$t('openMapBtn')"
                                class="p-button-secondary"
                                ref="TextBox_7"
                                @keyup.left="moveFocus($event, 'TextBox_6', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_8', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_3', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_8', 'Button')"
                            />
                        </div>
                        <!-- Doe:  เพิ่ม มุดmap 1/4 จบ-->
                    </div>

                    <!-- Doe เพิ่มหมุด map V.2 3/9  -->
                    <small class="warningLATLON" v-if="this.error_latlon_P || this.error_latlon_A || this.error_latlon_T || error_latlon_country"
                        >ข้อควรระวัง : ข้อมูลพิกัดที่คุณเลือกไม่สามารถระบุ
                        <span v-if="this.error_latlon_P || error_latlon_country"> จังหวัด </span>
                        <span v-if="this.error_latlon_A || error_latlon_country"> เขต/อำเภอ </span>
                        <span v-if="this.error_latlon_T || error_latlon_country"> แขวง/ตำบล </span>
                        <span> ได้ </span>
                    </small>
                    <!-- Doe เพิ่มหมุด map V.2 3/9  จบ-->

                    <div class="p-formgrid p-grid p-mt-3" style="display: flex; justify-content: flex-end">
                        <div class="p-field p-col-12 p-lg-2">
                            <label for="date_create_form">วันที่สร้างข้อมูล <span class="required-input"> </span></label>
                            <InputText id="date_create_form" type="text" v-model="date_create_form" autofocus disabled />
                        </div>
                        <div class="p-field p-col-12 p-lg-2">
                            <label for="date_update_form">{{ $t('imp_update_info_date') }}<span class="required-input"> </span></label>
                            <InputText id="date_update_form" type="text" v-model="date_update_form" autofocus disabled />
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <!-- โหลดเพิ่มแก้ไข 2/8-->
                <Button
                    v-if="selectedData != ''"
                    :label="$t('cancelBtn')"
                    icon="pi pi-times"
                    class="p-button-text"
                    :disabled="loadingCreate ? true : false"
                    @click="clearData()"
                    ref="TextBox_8"
                    @keyup.left="moveFocus($event, 'TextBox_7', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_9', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_7', 'Button')"
                />
                <Button
                    v-else
                    :label="$t('clearBtn')"
                    icon="pi pi-times"
                    class="p-button-text"
                    :disabled="loadingCreate ? true : false"
                    @click="clearData()"
                    ref="TextBox_8"
                    @keyup.left="moveFocus($event, 'TextBox_7', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_9', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_7', 'Button')"
                />
                <Button
                    :label="$t('saveBtn')"
                    icon="pi pi-check"
                    class="p-button-text"
                    :disabled="loadingCreate ? true : false"
                    @click="saveData()"
                    ref="TextBox_9"
                    @keyup.left="moveFocus($event, 'TextBox_8', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_1', 'Input')"
                    @keyup.up="moveFocus($event, 'TextBox_7', 'Button')"
                />
                <!-- โหลดเพิ่มแก้ไข 2/8 จบ-->
            </template>
        </Dialog>

        <Dialog :modal="true" :header="$t('ConfirmDelete')" :visible.sync="displayConfirmation" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <i class="pi pi-exclamation-triangle p-mr-3 p-mt2" style="font-size: 2rem" />
                <span>{{ $t('ConfirmDeleteSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmation = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="confirmDelete(temp)" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <Dialog :modal="true" :header="$t('map')" :visible.sync="displayMap" :style="{ width: '700px' }">
            <div class="confirmation-content p-mt-3" style="padding-bottom: 20px">
                <!-- Doe : เพิ่ม มุดmap 2/4 -->
                <!-- Doe เพิ่มหมุด map V.2 4/9  -->
                <map-area @selectMap="selectMap_passValue" :latlon="this.latlon" :PAT="this.PAT" :FSS="{}" @selectMap_PAT="receiveM_PAT"></map-area>
                <!-- Doe เพิ่มหมุด map V.2 4/9  จบ-->
                <!-- Doe :  เพิ่ม มุดmap 2/4 -->
            </div>
            <Button :label="$t('saveBtn')" icon="pi pi-check" class="p-button-text" @click="selectMap_displayMap()" />
        </Dialog>

        <!-- Are you sure for close this modal -->
        <Dialog :modal="true" :header="$t('ConfirmCloseModal')" :visible.sync="displayConfirmationCloseModal" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <span>{{ $t('ConfirmCloseModalSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmationCloseModal = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="closeAllModal()" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <!-- Doe PDF เลือกได้  -->
        <Dialog header="ตั้งค่า " :visible.sync="displayEditPDF" :style="{ width: '25rem' }" :contentStyle="{ 'overflow-y': 'visible' }">
            <label>ตั้งค่าการแสดงข้อมูลตารางและการส่งออกข้อมูล</label>
            <div style="margin: 2.5rem 1rem 0 1rem">
                <div class="p-formgrid p-grid">
                    <div class="p-field p-col-12">
                        <MultiSelect
                            v-model="columnsSelectorDialog"
                            :options="columns"
                            optionLabel="title"
                            :placeholder="$t('placeholderSelectBox')"
                            :filter="true"
                            class="multiselect-custom"
                            :clearFilterMultiSelect="multiSelectClearFilerValue"
                        >
                            <template #value="slotProps">
                                <div class="item item-value" v-for="option of slotProps.value" :key="option.dataKey">
                                    <div>{{ option.title }}</div>
                                </div>
                                <template v-if="!slotProps.value || slotProps.value.length === 0">
                                    {{ $t('placeholderSelectBox') }}
                                </template>
                            </template>
                            <template #option="slotProps">
                                <div class="item">
                                    <div>{{ slotProps.option.title }}</div>
                                </div>
                            </template>
                        </MultiSelect>
                        <div style="margin-top: 1rem; display: flex; justify-content: flex-end">
                            <Button
                                @click="
                                    ClearEditPDF();
                                    multiSelectClearFilerValue += 1;
                                "
                                class="p-button-clear"
                                :label="'ล้างข้อมูล'"
                                style="margin-right: 1rem"
                            />
                            <Button @click="SelectAllEditPDF()" class="p-button-info" :label="'เลือกทั้งหมด'" />
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <div>
                    <Button @click="CloseEditPDF()" :label="'ยกเลิก'" icon="pi pi-times" class="p-button-text" />
                    <Button @click="SaveEditPDF()" :label="'บันทึก'" icon="pi pi-check" class="p-button-text" />
                </div>
            </template>
        </Dialog>
        <!-- Doe PDF เลือกได้ -->
    </div>
</template>

<script>
import mapArea from '../Map';
// Doe : PDF 2/3
// เพิ่ม pdf กับ font
// import { jsPDF } from "jspdf";
// import {font} from '../../../../public/assets/font/Sarabun-Regular-normal';
// Doe : PDF 2/3 จบ
import moment from 'moment';

import textFooter from '../../../mixins/textFooter_Search_html';

export default {
    name: 'initial-FireStation',
    components: {
        mapArea,
        textFooter
    },
    data() {
        return {
            searchTimeout: null,
            searchInputRef: null,
            multiSelectClearFilerValue: 0,
            dropdownClearFilerValue: 0,
            date: moment().locale('th').add(543, 'year').format('l'),
            // Doe ค้นหา  2/6
            filter: '',
            ms: false,
            cloneTable: [],
            // Doe ค้นหา  2/6 จบ

            // Doe โหลด โทรศัพท์
            // Doe width 1/4
            window: {
                width: 0,
                height: 0
            },

            checkRole: null,
            checkView_data: null,
            checkAdd_data: null,
            checkEdit_data: null,
            checkDelete_data: null,

            // FireHydrant_Table: [],
            provinceOptions: [],
            selectedProvince: null,
            amphurOptions: [],
            selectedAmphur: null,
            isDisabledAmphur: 1,
            tambonOptions: [],
            selectedTambon: null,
            isDisabledTambon: 1,

            selectedFireHydrant: [],

            community_name: '',
            icommu_community_name: '',
            error_icommu_community_name: false,

            community_organize: '',
            icommu_community_organize: '',

            soi_name: '',
            icommu_soi_name: '',

            kpd: '',
            icommu_kpd: '',

            road_name: '',
            icommu_road_name: '',

            type_detail: null,
            type_detailOption: [],
            // type:"",
            icommu_type_detail: null,
            icommu_type_detailOption: [],
            error_icommu_type_detail: false,
            icommu_type: '',

            risk_level: '',
            risk_levelSelect: null,
            risk_levelOption: ['เลือกทั้งหมด', '1', '2', '3'],
            icommu_risk_levelSelect: null,
            icommu_risk_levelOption: ['1', '2', '3'],
            error_icommu_risk_levelSelect: false,

            icommu_area: '',
            icommu_population: '',
            icommu_house: '',

            icommu_remark: '',

            header_FireStation: this.$i18n.t('ifs_modal_title_add'),
            FireStation_Table: [],

            event_detail: '',
            ifs_event_detail: '',

            house_no: '',
            ifs_house_no: '',

            ifs_FireStation: '',
            error_ifs_FireStation: false,

            // Doe เพิ่ม สถานีดับเพลิงและกู้ภัย
            FireStationOptions: [],
            FireStationSelected: null,
            error_FireStation: false,
            FireStationOptions_AT: [],
            FireStationOptions_Form: [],

            // ifh_FireStationOptions:[],
            ifh_FireStationSelected: null,
            error_ifh_FireStationSelected: false,

            // Doe ชุมชน
            ifh_community_name: '',
            // community_name:"",
            error_ifh_community: false,

            ifh_soi_name: '',
            // soi_name:"",

            pipe_size: '',
            // road_name: "",
            ifh_pipe_size: '',
            ifh_road_name: '',

            filters: {},
            temp: null,
            showOrganize: false,
            // selectedFireHydrant: null,
            selectedOrganize: {},
            location_name: '',
            displayConfirmation: false,
            displayMap: false,

            disaster_table: [],
            disasterOptions: [],
            disasterSelect: null,

            riskLevelOptions: [],
            riskLevelSelected: null,

            selectedData: '',

            FireStationModal: false,
            ira_location_name: '',
            ira_location_detail: '',
            ira_selectedOrganize: {},
            ifh_selectedProvince: null,
            ira_selectedAmphur: null,
            ira_selectedTambon: null,
            ira_isDisabledAmphur: 1,
            ira_isDisabledTambon: 1,
            ira_disasterTypeSelected: null,
            ira_riskLevelSelected: null,
            ifh_lat: '',
            ifh_lon: '',

            error_ifh_selectedProvince: false,
            error_ira_selectedAmphur: false,
            error_ira_selectedTambon: false,
            error_ira_selectedOrganize: false,
            error_ira_location_name: false,
            error_ira_selectedDisaster: false,

            error_ifh_pipe_size: false,
            error_commu_road_name: false,
            error_ifh_lat: false,
            error_ifh_lon: false,

            check_duplicate: '',
            displayConfirmationCloseModal: false,
            tempFor_displayConfirmationCloseModal: '',
            // เพิ่ม มุดmap 3/4
            //  Doe เพิ่มหมุด map V.2 5/9  -->
            latlon: {},
            PAT: {},
            FSS: {},
            sP: [],
            sA: [],
            error_latlon_country: false,
            error_latlon_land: false,
            error_latlon_P: false,
            error_latlon_A: false,
            error_latlon_T: false,
            iP: 0,
            iA: 0,
            //  Doe เพิ่มหมุด map V.2 5/9  จบ-->
            // เพิ่ม มุดmap 3/4 จบ

            Dropdown_Fire_type: '',
            Dropdown_Fire_boundary: '',
            Dropdown_Fire_id: '',

            // Doe : PDF 3/3

            loading: false,

            // โหลดเพิ่มแก้ไข 3/8
            loadingCreate: false,
            // โหลดเพิ่มแก้ไข 3/8 จบ

            //
            text_Footer: false,
            Clone_Data_text_Footer: [],
            Data_text_Footer: [
                {
                    DataName: 'จังหวัด',
                    textShow: ''
                },
                {
                    DataName: 'เขต/อำเภอ',
                    textShow: ''
                },
                {
                    DataName: 'แขวง/ตำบล',
                    textShow: ''
                },
                {
                    DataName: 'สถานีดับเพลิงและกู้ภัย',
                    textShow: ''
                },
                {
                    DataName: 'เลขที่',
                    textShow: ''
                },
                {
                    DataName: 'ซอย/ตรอก',
                    textShow: ''
                },
                {
                    DataName: 'ถนน',
                    textShow: ''
                }
            ],

            table_BOXmanege: window.innerWidth > 700 ? 'p-field p-col' : '',
            table_editBTN: window.innerWidth > 700 ? this.$i18n.t('editBtn') : '',
            table_deleteBTN: window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '',

            table_headerStyle: this.checkInnerWidth('15rem', 'Column'),
            table_bodyStyle: this.checkInnerWidth('15rem', 'Body'),

            date_create_form: '',
            date_update_form: '',
            // Doe PDF เลือกได้  2/5
            setPDF_Hor: 'l',
            setPosition_Hor: [802, 34, 802, 570],
            setPDF_Ver: 'p',
            setPosition_Ver: [570, 34, 575, 815],
            setPDF_Styles: 'grid',
            setnamePDF: 'ตารางข้อมูลสถานีดับเพลิงและกู้ภัย',
            setPDF_fillColor: [95, 154, 250],
            setPDF_Margin: { left: 15, right: 15 },

            PDF_minCellWidthVer: 40,
            PDF_FontHeaderVer: 9,
            PDF_FontBodyVer: 7,

            PDF_BodySizeSelect: {},
            PDF_BodySize: {
                index: { cellWidth: 24 },

                house_no: { cellWidth: 27 },
                // event_lon:{cellWidth:45}
                event_latPDF: { cellWidth: 35 },
                event_lonPDF: { cellWidth: 35 }
            },

            PDF_minCellWidthHor: 50,
            PDF_FontHeaderHor: 12,
            PDF_FontBodyHor: 10,

            PDF_BodySizeHorSelect: {},
            PDF_BodySizeHor: {
                index: { cellWidth: 30 },
                house_no: { cellWidth: 35 },
                // event_lat:{cellWidth:55},
                // event_lon:{cellWidth:55}
                event_latPDF: { cellWidth: 50 },
                event_lonPDF: { cellWidth: 50 }
            },
            columns: [
                { title: 'ลำดับ', dataKey: 'index' },
                { title: 'สถานีดับเพลิงและกู้ภัย', dataKey: 'fs_tname' },

                { title: 'เลขที่', dataKey: 'house_no' },
                { title: 'ซอย/ตรอก', dataKey: 'soi_name' },
                { title: 'ถนน', dataKey: 'road_name' },
                { title: 'แขวง/ตำบล', dataKey: 'tambon_name' },
                { title: 'เขต/อำเภอ', dataKey: 'amphur_name' },
                { title: 'จังหวัด', dataKey: 'province_name' },
                // {title: "ละติจูด", dataKey: "event_lat"},
                // {title: "ลองจิจูด", dataKey: "event_lon"},
                { title: 'ละติจูด', dataKey: 'event_latPDF' },
                { title: 'ลองจิจูด', dataKey: 'event_lonPDF' },
                { title: 'วันที่สร้างข้อมูล', dataKey: 'date_create_ddmmyy' },
                { title: 'วันที่ปรับปรุงข้อมูล', dataKey: 'date_update_ddmmyy' }
            ],

            columnsSelector: null,
            columnsSelectorDialog: null,

            displayEditPDF: false,

            columns_index: true,
            columns_fs_tname: true,
            columns_house_no: true,
            columns_soi_name: true,
            columns_road_name: true,
            columns_tambon_name: true,
            columns_amphur_name: true,
            columns_province_name: true,
            columns_event_lat: true,
            columns_event_lon: true,

            columns_date_create: true,
            columns_date_update: true,

            columns_disabled: true,
            // Doe PDF เลือกได้  2/5  จบ

            items: [
                {
                    label: ' แนวตั้ง',
                    command: () => {
                        this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวตั้ง', life: 3000 });

                        // let dateObj = new Date();
                        // const result = dateObj.toLocaleDateString('th-TH', {
                        //   year: 'numeric',
                        //   month: 'long',
                        //   day: 'numeric',
                        // })
                        // let time = `${dateObj.getDate()}-${dateObj.getMonth()+1}-${dateObj.getFullYear()+543}`
                        // // const columns =
                        // //   [
                        // //       {title: "ลำดับ", dataKey: "index" },
                        // //       {title: "สถานีดับเพลิงและกู้ภัย", dataKey: "fs_tname"},
                        // //       // {title: "ที่อยู่", dataKey: "event_detail" },
                        // //       {title: "เลขที่", dataKey: "house_no" },
                        // //       {title: "ซอย", dataKey: "soi_name"},
                        // //       {title: "ถนน", dataKey: "road_name"},
                        // //       {title: "แขวง/ตำบล", dataKey: "tambon_name"},
                        // //       {title: "เขต/อำเภอ", dataKey: "amphur_name"},
                        // //       {title: "จังหวัด", dataKey: "province_name"},
                        // //       {title: "ละติจูด", dataKey: "event_lat"},
                        // //       {title: "ลองจิจูด", dataKey: "event_lon"},

                        // //   ];
                        //   const doc = new jsPDF('p', 'pt');
                        //   doc.addFileToVFS("m.ttf", font);
                        //       doc.addFont("m.ttf","m","normal");
                        //       doc.setFont("m");

                        //   doc.autoTable({
                        //     margin: { left: 15 ,right:15 },
                        //     styles: {

                        //               font:'m',

                        //             },
                        //             headStyles:{
                        //               fontSize: this.PDF_FontHeaderVer,
                        //               fontStyle: 'bolder',
                        //               minCellWidth: this.PDF_minCellWidthVer,
                        //               halign: 'center',
                        //               valign: 'middle',
                        //               fillColor:[95,154,250]
                        //             },
                        //             bodyStyles:{
                        //               fontSize: this.PDF_FontBodyVer,

                        //             },
                        //             columnStyles: this.PDF_BodySizeSelect,
                        //     columns: this.columnsSelector,
                        //     body: this.FireStation_Table,
                        //     // body:this.$refs.dt.processedData,
                        //     theme:'grid',

                        //       didParseCell:  (HookData) =>{
                        //         if (HookData.cell.text[0]== '' || HookData.cell.text[0]== null ||  HookData.cell.text[0]== 'null' || HookData.cell.text[0]== undefined ) {

                        //             HookData.cell.text = '-';
                        //         }
                        //         if (HookData.cell.text[0]== '-'  ) {
                        //         // console.log(HookData)
                        //         HookData.cell.styles.halign = 'center';
                        //         HookData.cell.styles.valign = 'middle';
                        //     }

                        //     const column = HookData.column.dataKey
                        //     if(column == "index" || column == "tambon_name" ||
                        //       column == "amphur_name" || column == "province_name" ||
                        //       column == "event_latPDF" || column == "event_lonPDF" ||
                        //       column == "house_no" ){
                        //             HookData.cell.styles.halign = 'center';
                        //         }
                        //       },
                        //       didDrawPage: () => {
                        //       doc.setFontSize(13);
                        //       doc.text("ข้อมูล ณ วันที่ "+result,  570, 34, null, null, "right")
                        //       }
                        //   });

                        //   var pageCount = doc.internal.getNumberOfPages()
                        //   // console.log("pageCount",pageCount)
                        //   for (let index = 0; index < pageCount; index++) {
                        //     doc.setPage(index)
                        //     doc.setFontSize(13);
                        //     let pageCurrent = doc.internal.getCurrentPageInfo().pageNumber
                        //     doc.text("หน้า "+pageCurrent + " จาก " +pageCount,575,815, null, null, "right")
                        //   }

                        //   doc.save('ตารางข้อมูลสถานีดับเพลิงและกู้ภัย(แนวตั้ง)'+ time +'.pdf');

                        let columns = this.columnsSelector;
                        columns = columns.filter(function (item) {
                            return item.dataKey != 'image';
                        });

                        const Body_setCenter = ['index', 'tambon_name', 'amphur_name', 'province_name', 'event_latPDF', 'event_lonPDF', 'house_no'];

                        const PintPDF = {
                            streak: this.setPDF_Ver,
                            setPosition: this.setPosition_Ver,
                            PDF_Styles: this.setPDF_Styles,
                            data: this.$refs.dt.processedData,
                            columns: columns,
                            columnsStyles: this.PDF_BodySizeSelect,
                            FileName: this.setnamePDF,
                            checkBody_Center: true,
                            Body_Center: Body_setCenter,
                            Col_FontSize: this.PDF_FontHeaderVer,
                            Body_FontSize: this.PDF_FontBodyVer,
                            minCell: this.PDF_minCellWidthVer,
                            marginPDF: this.setPDF_Margin,
                            fillColorPDF: this.setPDF_fillColor
                        };
                        this.printPDF(PintPDF);
                    }
                },

                {
                    label: 'แนวนอน',
                    command: () => {
                        this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวนอน', life: 3000 });

                        let columns = this.columnsSelector;
                        columns = columns.filter(function (item) {
                            return item.dataKey != 'image';
                        });

                        const Body_setCenter = ['index', 'tambon_name', 'amphur_name', 'province_name', 'event_latPDF', 'event_lonPDF', 'house_no'];

                        const PintPDF = {
                            streak: this.setPDF_Hor,
                            setPosition: this.setPosition_Hor,
                            PDF_Styles: this.setPDF_Styles,
                            data: this.$refs.dt.processedData,
                            columns: columns,
                            columnsStyles: this.PDF_BodySizeHorSelect,
                            FileName: this.setnamePDF,
                            checkBody_Center: true,
                            Body_Center: Body_setCenter,
                            Col_FontSize: this.PDF_FontHeaderHor,
                            Body_FontSize: this.PDF_FontBodyHor,
                            minCell: this.PDF_minCellWidthHor,
                            marginPDF: this.setPDF_Margin,
                            fillColorPDF: this.setPDF_fillColor
                        };
                        this.printPDF(PintPDF);
                    }
                }
            ]
            // Doe : PDF 3/3 จบ
        };
    },
    watch: {
        async FireStationModal(val) {
            const today = new Date();
            const thaiDate = today.toLocaleDateString('th-TH', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });

            if (val == false) {
                if (
                    this.tempFor_displayConfirmationCloseModal == '' &&
                    this.selectedData == '' &&
                    this.ifs_FireStation != '' &&
                    this.ifh_selectedProvince != null &&
                    this.ira_isDisabledAmphur != null &&
                    this.ira_isDisabledTambon != null &&
                    this.ifh_lat != '' &&
                    this.ifh_lon != ''
                ) {
                    // this.displayConfirmationCloseModal = true;
                    this.$fire({
                        title: 'ยืนยันการปิดหน้าต่างจัดการข้อมูล',
                        text: 'คุณต้องการออกจากการจัดการข้อมูลใช่หรือไม่ ?',

                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'ตกลง',
                        cancelButtonText: 'ยกเลิก'
                    }).then((result) => {
                        if (result.value) {
                            this.FireStationModal = false;
                            this.clearData();
                        } else {
                            this.FireStationModal = true;
                        }
                    });
                } else {
                    this.clearData();
                    await this.axios
                        .post(`${this.$url_service}/general/country`, {
                            body: { topic: 'get-province' }
                        })
                        .then((response) => {
                            (this.provinceOptions = response.data.data),
                                this.provinceOptions.splice(0, 0, {
                                    province_id: 'getall',
                                    province_name: this.$i18n.t('selectAll')
                                });
                        });

                    this.check_Fire_Form_search(this.ira_selectedTambon, this.ira_selectedAmphur, this.ifh_selectedProvince, 'form', false);

                    await this.axios
                        .post(`${this.$url_service}/initial/firestation`, {
                            body: {
                                topic: 'get-option-firestation',
                                userData: this.getUser()
                            }
                        })
                        .then((response) => {
                            (this.FireStationOptions = response.data.data),
                                this.FireStationOptions.splice(0, 0, {
                                    fs_id: 'getall',
                                    fs_tname: this.$i18n.t('selectAll')
                                });
                        });
                }
            } else {
                if (this.temp === null) {
                    this.date_create_form = thaiDate;
                    this.date_update_form = thaiDate;
                }

                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-province'
                        }
                    })
                    .then((response) => (this.provinceOptions = response.data.data));

                this.check_Fire_Form_search(this.ira_selectedTambon, this.ira_selectedAmphur, this.ifh_selectedProvince, 'form', false);

                await this.axios
                    .post(`${this.$url_service}/initial/firestation`, {
                        body: {
                            topic: 'get-option-firestation',
                            userData: this.getUser()
                        }
                    })
                    .then((response) => {
                        this.FireStationOptions = response.data.data;
                    });
                await this.axios
                    .post(`${this.$url_service}/initial/option`, {
                        body: { group: 'dg-24' }
                    })
                    .then((response) => {
                        this.icommu_type_detailOption = response.data.data;

                        // console.log('this.icommu_type_detailOption = ',this.icommu_type_detailOption)
                    });
            }
        },

        displayConfirmationCloseModal(val) {
            if (val == true) {
                this.FireStationModal = true;
            }
        },

        async selectedProvince(val) {
            // this.FireStationSelected = null
            this.selectedAmphur = null;
            if (val != null) {
                this.isDisabledAmphur = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-amphur',
                            province_id: this.selectedProvince.province_id
                        }
                    })
                    .then((response) => {
                        (this.amphurOptions = response.data.data),
                            this.amphurOptions.splice(0, 0, {
                                amphur_id: 'getall',
                                amphur_name: this.$i18n.t('selectAll')
                            });
                    });

                // await this.axios
                //   .post(`${this.$url_service}/initial/firestation`, {
                //     body: {
                //       topic: "get-option-firestation",
                //       // province_id:this.selectedProvince == null ? "" :
                //       // this.selectedProvince.province_id == "getall" ? ""
                //       // : this.selectedProvince.province_id,
                //       // amphur_id:this.selectedAmphur == null ? "" :
                //       // this.selectedAmphur.amphur_id == "getall" ? ""
                //       // : this.selectedAmphur.amphur_id,
                //       // tambon_id:this.selectedTambon == null ? "" :
                //       // this.selectedTambon.tambon_id == "getall" ? ""
                //       // : this.selectedTambon.tambon_id
                //       province_id:"",
                //       amphur_id:"",
                //       tambon_id:""

                //     },
                //   })
                //   .then((response) => {

                //     this.FireStationOptions_AT = response.data.data
                //     if (this.FireStationOptions_AT.length > 1) {
                //       this.FireStationOptions_AT.splice(0, 0, {
                //         fs_id : "getall",
                //         fs_tname: this.$i18n.t("selectAll"),
                //       });
                //     }
                //       // console.log("this.FireStationOptions_AT",this.FireStationOptions_AT)
                //   });

                this.check_Fire_Form_search(this.selectedTambon, this.selectedAmphur, this.selectedProvince, 'search', true);
            } else {
                this.isDisabledAmphur = 1;
                this.selectedAmphur = null;
                // this.FireStationSelected = null

                this.check_Fire_Form_search(this.selectedTambon, this.selectedAmphur, this.selectedProvince, 'search', true);

                // await this.axios
                //   .post(`${this.$url_service}/initial/firestation`, {
                //     body: {
                //       topic: "get-option-firestation",
                //       // province_id:this.selectedProvince == null ? "" :
                //       // this.selectedProvince.province_id == "getall" ? ""
                //       // : this.selectedProvince.province_id,
                //       // amphur_id:this.selectedAmphur == null ? "" :
                //       // this.selectedAmphur.amphur_id == "getall" ? ""
                //       // : this.selectedAmphur.amphur_id,
                //       // tambon_id:this.selectedTambon == null ? "" :
                //       // this.selectedTambon.tambon_id == "getall" ? ""
                //       // : this.selectedTambon.tambon_id
                //       province_id:"",
                //       amphur_id:"",
                //       tambon_id:""
                //     },
                //   })
                //   .then((response) => {

                //     this.FireStationOptions_AT = response.data.data
                //     if (this.FireStationOptions_AT.length > 1) {
                //       this.FireStationOptions_AT.splice(0, 0, {
                //         fs_id : "getall",
                //         fs_tname: this.$i18n.t("selectAll"),
                //       });
                //     }
                //       // console.log("this.FireStationOptions_AT",this.FireStationOptions_AT)
                //   });
            }
        },

        selectedData(val) {
            // console.log("val",val)
            if (val != '') {
                if (val.location_id == 'null') {
                    this.ifh_selectedProvince = null;
                    this.ira_selectedAmphur = null;
                    this.ira_selectedTambon = null;
                } else {
                    this.ifh_selectedProvince = {
                        province_id: val.province_id,
                        province_name: val.province_name
                    };
                    this.ira_selectedAmphur = {
                        amphur_id: val.amphur_id,
                        amphur_name: val.amphur_name
                    };
                    this.ira_selectedTambon = {
                        tambon_id: val.location_id,
                        tambon_name: val.tambon_name
                    };
                }

                if (val.fire_station == '') {
                    this.ifh_FireStationSelected = null;
                }
            }
        },

        async selectedAmphur(val) {
            // this.FireStationSelected = null
            this.selectedTambon = null;
            if (val != null) {
                this.isDisabledTambon = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-tambon',
                            amphur_id: this.selectedAmphur.amphur_id
                        }
                    })
                    .then((response) => {
                        (this.tambonOptions = response.data.data),
                            this.tambonOptions.splice(0, 0, {
                                tambon_id: 'getall',
                                tambon_name: this.$i18n.t('selectAll')
                            });
                    });

                this.check_Fire_Form_search(this.selectedTambon, this.selectedAmphur, this.selectedProvince, 'search', true);

                // await this.axios
                //   .post(`${this.$url_service}/initial/firestation`, {
                //     body: {
                //       topic: "get-option-firestation",
                //       // province_id:this.selectedProvince == null ? "" :
                //       // this.selectedProvince.province_id == "getall" ? ""
                //       // : this.selectedProvince.province_id,
                //       // amphur_id:this.selectedAmphur == null ? "" :
                //       // this.selectedAmphur.amphur_id == "getall" ? ""
                //       // : this.selectedAmphur.amphur_id,
                //       // tambon_id:this.selectedTambon == null ? "" :
                //       // this.selectedTambon.tambon_id == "getall" ? ""
                //       // : this.selectedTambon.tambon_id
                //       province_id:"",
                //       amphur_id:"",
                //       tambon_id:""

                //     },
                //   })
                //   .then((response) => {

                //     this.FireStationOptions_AT = response.data.data
                //     if (this.FireStationOptions_AT.length > 1) {
                //       this.FireStationOptions_AT.splice(0, 0, {
                //         fs_id : "getall",
                //         fs_tname: this.$i18n.t("selectAll"),
                //       });
                //     }

                //   });
            } else {
                this.isDisabledTambon = 1;
                this.selectedTambon = null;
                // this.FireStationSelected = null

                this.check_Fire_Form_search(this.selectedTambon, this.selectedAmphur, this.selectedProvince, 'search', true);

                // await this.axios
                //     .post(`${this.$url_service}/initial/firestation`, {
                //       body: {
                //         topic: "get-option-firestation",
                //         // province_id:this.selectedProvince == null ? "" :
                //         // this.selectedProvince.province_id == "getall" ? ""
                //         // : this.selectedProvince.province_id,
                //         // amphur_id:this.selectedAmphur == null ? "" :
                //         // this.selectedAmphur.amphur_id == "getall" ? ""
                //         // : this.selectedAmphur.amphur_id,
                //         // tambon_id:this.selectedTambon == null ? "" :
                //         // this.selectedTambon.tambon_id == "getall" ? ""
                //         // : this.selectedTambon.tambon_id
                //         province_id:"",
                //         amphur_id:"",
                //         tambon_id:""

                //       },
                //     })
                //     .then((response) => {

                //       this.FireStationOptions_AT = response.data.data
                //       if (this.FireStationOptions_AT.length > 1) {
                //         this.FireStationOptions_AT.splice(0, 0, {
                //           fs_id : "getall",
                //           fs_tname: this.$i18n.t("selectAll"),
                //         });
                //       }
                //         // console.log("this.FireStationOptions_AT",this.FireStationOptions_AT)
                //     });
            }
        },
        async selectedTambon(val) {
            // this.FireStationSelected =null
            if (val != null) {
                this.check_Fire_Form_search(this.selectedTambon, this.selectedAmphur, this.selectedProvince, 'search', true);

                // await this.axios
                //   .post(`${this.$url_service}/initial/firestation`, {
                //     body: {
                //       topic: "get-option-firestation",
                //       // province_id:this.selectedProvince == null ? "" :
                //       // this.selectedProvince.province_id == "getall" ? ""
                //       // : this.selectedProvince.province_id,
                //       // amphur_id:this.selectedAmphur == null ? "" :
                //       // this.selectedAmphur.amphur_id == "getall" ? ""
                //       // : this.selectedAmphur.amphur_id,
                //       // tambon_id:this.selectedTambon == null ? "" :
                //       // this.selectedTambon.tambon_id == "getall" ? ""
                //       // : this.selectedTambon.tambon_id
                //       province_id:"",
                //       amphur_id:"",
                //       tambon_id:""

                //     },
                //   })
                //   .then((response) => {

                //     this.FireStationOptions_AT = response.data.data
                //     if (this.FireStationOptions_AT.length > 1) {
                //       this.FireStationOptions_AT.splice(0, 0, {
                //         fs_id : "getall",
                //         fs_tname: this.$i18n.t("selectAll"),
                //       });
                //     }
                //       // console.log("this.FireStationOptions_AT",this.FireStationOptions_AT)
                //   });
            } else {
                this.selectedTambon = null;
                // this.FireStationSelected =null

                this.check_Fire_Form_search(this.selectedTambon, this.selectedAmphur, this.selectedProvince, 'search', true);

                // await this.axios
                //   .post(`${this.$url_service}/initial/firestation`, {
                //     body: {
                //       topic: "get-option-firestation",
                //       // province_id:this.selectedProvince == null ? "" :
                //       // this.selectedProvince.province_id == "getall" ? ""
                //       // : this.selectedProvince.province_id,
                //       // amphur_id:this.selectedAmphur == null ? "" :
                //       // this.selectedAmphur.amphur_id == "getall" ? ""
                //       // : this.selectedAmphur.amphur_id,
                //       // tambon_id:this.selectedTambon == null ? "" :
                //       // this.selectedTambon.tambon_id == "getall" ? ""
                //       // : this.selectedTambon.tambon_id
                //       province_id:"",
                //       amphur_id:"",
                //       tambon_id:""

                //     },
                //   })
                //   .then((response) => {

                //     this.FireStationOptions_AT = response.data.data
                //     if (this.FireStationOptions_AT.length > 1) {
                //       this.FireStationOptions_AT.splice(0, 0, {
                //         fs_id : "getall",
                //         fs_tname: this.$i18n.t("selectAll"),
                //       });
                //     }
                //       // console.log("this.FireStationOptions_AT",this.FireStationOptions_AT)
                //   });
            }
        },
        async ifh_selectedProvince(val) {
            if (val != null) {
                this.ira_isDisabledAmphur = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-amphur',
                            province_id: this.ifh_selectedProvince.province_id
                        }
                    })
                    .then((response) => (this.amphurOptions = response.data.data));

                this.Fire_Form();
            } else {
                this.ira_isDisabledAmphur = 1;
                this.ira_selectedAmphur = null;
                this.Fire_Form();
            }
        },

        async ira_selectedAmphur(val) {
            if (val != null) {
                this.ira_isDisabledTambon = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-tambon',
                            amphur_id: this.ira_selectedAmphur.amphur_id
                        }
                    })
                    .then((response) => (this.tambonOptions = response.data.data));
                this.Fire_Form();
            } else {
                this.ira_isDisabledTambon = 1;
                this.ira_selectedTambon = null;
                this.Fire_Form();
            }
        },

        async ira_selectedTambon(val) {
            if (val != null) {
                this.Fire_Form();
            } else {
                this.Fire_Form();
            }
        },
        // Doe PDF เลือกได้
        columnsSelector(val) {
            if (val.length == 0) {
                this.FireStation_Table = [];
            } else {
                this.FireStation_Table = this.cloneTable;
            }
        }
    },
    created() {
        // Doe โหลด โทรศัพท์
        // Doe width 2/4
        window.addEventListener('resize', this.handleResize);
        this.handleResize();

        if (this.window.width <= 430) {
            // console.log("this.window.width is",this.window.width)
            // console.log("00000")
            this.searchMenu();
        } else {
            // console.log("this.window.width is",this.window.width)
            // console.log("1111")
            this.ms = true;
            this.initialData();
        }
        // Doe โหลด โทรศัพท์

        // Doe PDF เลือกได้  4/5
        this.columnsSelector = this.columns;
        this.PDF_BodySizeSelect = this.PDF_BodySize;
        this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;
        // Doe PDF เลือกได้  4/5  จบ

        const decodedToken = this.decodeJWT(localStorage.getItem('token'));
        // this.initialData();
        this.checkRole = decodedToken.permission_id;

        this.checkView_data = decodedToken.view_data;
        this.checkAdd_data = decodedToken.add_data;
        this.checkEdit_data = decodedToken.edit_data;
        this.checkDelete_data = decodedToken.delete_data;

        // console.log(`checkRole = ${this.checkRole} `);
        // console.log(`checkView_data = ${this.checkView_data} `);
        // console.log(`checkAdd_data = ${this.checkAdd_data} `);
        // console.log(`checkEdit_data = ${this.checkEdit_data} `);
        // console.log(`checkDelete_data = ${this.checkDelete_data} `);

        this.Clone_Data_text_Footer = this.setCloneData(this.Data_text_Footer);
    },

    // Doe โหลด โทรศัพท์
    // Doe width 3/4
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    // Doe โหลด โทรศัพท์

    mounted() {
        this.$nextTick(() => {
            this.searchInputRef = this.$refs.searchInput?.$el || this.$refs.searchInput;
        });
    },

    methods: {
        async updateDates() {
            try {
                this.loadingCreate = true;
                const userOrg = this.getUserOrganize();
                const userId = this.getUsername();

                // Format selected records
                const formattedRecords = this.selectedFireHydrant.map((item) => ({
                    fs_id: item.fs_id,
                    ...item
                }));

                // console.log('formattedRecords', formattedRecords);

                const response = await this.axios.post(`${this.$url_service}/initial/firestation?user=${userId}`, {
                    body: {
                        topic: 'edit-fire_station_date_multiple',
                        selectedFireHydrant: formattedRecords,
                        userOrg: userOrg
                    }
                });

                // Check if response exists and has data
                if (response && response.data) {
                    if (response.data.success) {
                        this.loadingCreate = false;
                        this.tempFor_displayConfirmationCloseModal = 'add';
                        this.FireStationModal = false;

                        await this.$fire({
                            type: 'success',
                            title: 'ปรับปรุงข้อมูล',
                            text: `อัปเดตข้อมูลสถานีดับเพลิงและกู้ภัยจำนวน ${response.data.updatedIds?.length || 0} รายการ`,
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });

                        // Refresh data after successful update
                        await this.searchFireStation();
                    } else {
                        throw new Error(response.data.message || 'ไม่สามารถอัปเดตข้อมูลได้');
                    }
                }
            } catch (error) {
                this.loadingCreate = false;
                await this.$fire({
                    type: 'error',
                    title: 'เกิดข้อผิดพลาด',
                    text: error.response?.data?.message || error.message || 'ไม่สามารถอัปเดตข้อมูลได้',
                    timer: 3000,
                    confirmButtonColor: '#DC3545'
                });
            } finally {
                this.loadingCreate = false;
            }
        },

        onSelectAll(checked) {
            if (checked) {
                this.selectedFireHydrant = [...this.FireStation_Table];
            } else {
                this.selectedFireHydrant = [];
            }
            this.$emit('selectedFireHydrant', this.selectedFireHydrant);
            // console.log('selectedFireHydrant', this.selectedFireHydrant);
        },

        onSelectRow(row, checked) {
            if (checked) {
                if (!this.selectedFireHydrant.some((item) => item.fs_id === row.fs_id)) {
                    this.selectedFireHydrant.push(row);
                }
            } else {
                this.selectedFireHydrant = this.selectedFireHydrant.filter((item) => item.fs_id !== row.fs_id);
            }
            this.$emit('selectedFireHydrant', this.selectedFireHydrant);
            // console.log('selectedFireHydrant', this.selectedFireHydrant);
        },

        decodeJWT(token) {
            try {
                const payload = token.split('.')[1];
                // Replace Base64URL to Base64
                const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
                // Decode Base64
                const decodedPayload = atob(base64);
                // Handle UTF-8 encoding and return the parsed JSON object
                const jsonPayload = decodeURIComponent(
                    decodedPayload
                        .split('')
                        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                        .join('')
                );
                return JSON.parse(jsonPayload);
            } catch (error) {
                console.error('Failed to decode JWT token:', error);
                return null;
            }
        },

        getUser() {
            const getUser = this.decodeJWT(localStorage.getItem('token'));
            if (typeof getUser == 'string') {
                return JSON.parse(getUser);
            }
            return getUser;
        },
        saveData_Modal(ModalName) {
            if (ModalName === 'search') {
                if (!this.isFocused('TextBox_4_search') && !this.isFocused('TextBox_5_search')) {
                    this.searchFireStation();
                }
            } else if (ModalName === 'Modal_Main') {
                if (!this.isFocused('TextBox_7') && !this.isFocused('TextBox_8') && !this.isFocused('TextBox_9')) {
                    this.saveData();
                }
            }
        },

        exportCSV() {
            debugger;
            this.$refs.dt.exportCSV();
        },
        async Fire_Form_search(status) {
            const url = `https://service.deemap.com/service/gismis/tools/analysis`;
            await this.axios
                .post(url, {
                    key: '78e731027d8fd50ed642340b7c9a63b3',
                    topic: 'fireStationIntersectGeocode',
                    type: this.Dropdown_Fire_type,
                    boundary: this.Dropdown_Fire_boundary,
                    id: this.Dropdown_Fire_id
                })
                .then((response) => {
                    const data = this.Dropdown_Fire_type === 'polygon' ? response.data.data.features : response.data.data;
                    let data_option = [];
                    if (data.length !== 0) {
                        for (let index = 0; index < data.length; index++) {
                            const element = this.Dropdown_Fire_type === 'polygon' ? data[index].properties.fire_tname : data[index].fire_tname;
                            data_option.push({ fs_tname: element });
                        }
                    }

                    if (status === 'search') {
                        this.FireStationOptions_AT = data_option;
                        if (this.FireStationOptions_AT.length > 1) {
                            this.FireStationOptions_AT.splice(0, 0, {
                                fs_tname: this.$i18n.t('selectAll')
                            });
                        }
                        // console.log("this.FireStationOptions_AT",this.FireStationOptions_AT)
                    } else {
                        this.FireStationOptions_Form = data_option;
                    }
                });
        },
        check_Fire_Form_search(Tambon, Amphur, Province, status, clear) {
            if (Tambon !== null && Amphur !== null && Province !== null) {
                if (Tambon.tambon_id === 'getall') {
                    if (Province.province_id === 'getall') {
                        this.Dropdown_Fire_type = '';
                        this.Dropdown_Fire_boundary = 'all';
                        this.Dropdown_Fire_id = '';
                    } else if (Amphur.amphur_id === 'getall') {
                        this.Dropdown_Fire_type = '';
                        this.Dropdown_Fire_boundary = 'province';
                        this.Dropdown_Fire_id = Province.province_id;
                    } else {
                        this.Dropdown_Fire_type = '';
                        this.Dropdown_Fire_boundary = 'amphoe';
                        this.Dropdown_Fire_id = Amphur.amphur_id;
                    }
                } else {
                    this.Dropdown_Fire_type = '';
                    this.Dropdown_Fire_boundary = 'tambon';
                    this.Dropdown_Fire_id = Tambon.tambon_id;
                }
            } else if (Amphur !== null && Province !== null) {
                if (Amphur.amphur_id === 'getall') {
                    if (Province.province_id === 'getall') {
                        this.Dropdown_Fire_type = '';
                        this.Dropdown_Fire_boundary = 'all';
                        this.Dropdown_Fire_id = '';
                    } else {
                        this.Dropdown_Fire_type = '';
                        this.Dropdown_Fire_boundary = 'province';
                        this.Dropdown_Fire_id = Province.province_id;
                    }
                } else {
                    this.Dropdown_Fire_type = '';
                    this.Dropdown_Fire_boundary = 'amphoe';
                    this.Dropdown_Fire_id = Amphur.amphur_id;
                }
            } else if (Province !== null) {
                if (Province.province_id === 'getall') {
                    this.Dropdown_Fire_type = '';
                    this.Dropdown_Fire_boundary = 'all';
                    this.Dropdown_Fire_id = '';
                } else {
                    this.Dropdown_Fire_type = '';
                    this.Dropdown_Fire_boundary = 'province';
                    this.Dropdown_Fire_id = Province.province_id;
                }
            } else {
                this.Dropdown_Fire_type = '';
                this.Dropdown_Fire_boundary = 'all';
                this.Dropdown_Fire_id = '';
            }

            if (status === 'search') {
                if (clear === true) {
                    this.FireStationSelected = null;
                }

                this.Fire_Form_search(status);
            } else {
                if (this.selectedData == '') {
                    this.ifh_FireStationSelected = null;
                } else if (Tambon === null || Amphur === null || Province === null) {
                    this.ifh_FireStationSelected = null;
                }
                this.Fire_Form_search(status);
            }
        },
        async Fire_Form() {
            if (this.selectedData == '') {
                this.ifh_FireStationSelected = null;
            }

            // this.selectedProvince = null
            await this.axios
                .post(`${this.$url_service}/initial/firestation`, {
                    body: {
                        topic: 'get-option-firestation',
                        userData: this.getUser(),
                        province_id:
                            this.ifh_selectedProvince == null
                                ? ''
                                : this.ifh_selectedProvince.province_id == 'getall'
                                ? ''
                                : this.ifh_selectedProvince.province_id,
                        amphur_id:
                            this.ira_selectedAmphur == null
                                ? ''
                                : this.ira_selectedAmphur.amphur_id == 'getall'
                                ? ''
                                : this.ira_selectedAmphur.amphur_id,
                        tambon_id:
                            this.ira_selectedTambon == null
                                ? ''
                                : this.ira_selectedTambon.tambon_id == 'getall'
                                ? ''
                                : this.ira_selectedTambon.tambon_id
                    }
                })
                .then((response) => {
                    this.FireStationOptions_Form = response.data.data;

                    // console.log("this.FireStationOptions_AT",this.FireStationOptions_AT)
                });
        },
        // Doe โหลด โทรศัพท์
        // Doe width 4/4
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;

            this.table_BOXmanege = window.innerWidth > 700 ? 'p-field p-col' : '';
            this.table_editBTN = window.innerWidth > 700 ? this.$i18n.t('editBtn') : '';
            this.table_deleteBTN = window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '';
            if (window.innerWidth > 700) {
                this.table_headerStyle = this.checkInnerWidth('15rem', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('15rem', 'Body');
            } else {
                this.table_headerStyle = this.checkInnerWidth('105px', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('105px', 'Body');
            }
        },

        async searchMenu() {
            // console.log("79")
            await this.axios
                .post(`${this.$url_service}/general/country`, {
                    body: {
                        topic: 'get-province'
                    }
                })
                .then((response) => {
                    (this.provinceOptions = response.data.data),
                        this.provinceOptions.splice(0, 0, {
                            province_id: 'getall',
                            province_name: this.$i18n.t('selectAll')
                        });
                });

            this.check_Fire_Form_search(this.selectedTambon, this.selectedAmphur, this.selectedProvince, 'search', true);

            await this.axios
                .post(`${this.$url_service}/initial/firestation`, {
                    body: {
                        topic: 'get-option-firestation',
                        userData: this.getUser()
                    }
                })
                .then((response) => {
                    (this.FireStationOptions = response.data.data),
                        this.FireStationOptions.splice(0, 0, {
                            fs_id: 'getall',
                            fs_tname: this.$i18n.t('selectAll')
                        });
                    // console.log("this.FireStationOptions",this.FireStationOptions)
                });
        },

        // Doe โหลด โทรศัพท์

        // Doe ค้นหา  3/6
        search() {
            // Store reference to the input element
            if (event && event.target) {
                this.searchInputRef = event.target;
            }

            // Cancel any existing timeout
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout);
            }

            // Use debounce to delay processing
            this.searchTimeout = setTimeout(() => {
                if (this.filter != '') {
                    this.FireStation_Table = this.cloneTable.filter((item) => {
                        return (
                            (this.columns_fs_tname ? item.fs_tname.includes(this.filter) : '') ||
                            (this.columns_soi_name ? item.soi_name.includes(this.filter) : '') ||
                            (this.columns_road_name ? item.road_name.includes(this.filter) : '') ||
                            (this.columns_province_name ? item.province_name.includes(this.filter) : '') ||
                            (this.columns_tambon_name ? item.tambon_name.includes(this.filter) : '') ||
                            (this.columns_amphur_name ? item.amphur_name.includes(this.filter) : '') ||
                            (this.columns_house_no ? item.house_no.includes(this.filter) : '') ||
                            (this.columns_event_lat ? item.event_lat.includes(this.filter) : '') ||
                            (this.columns_event_lon ? item.event_lon.includes(this.filter) : '') ||
                            (this.columns_date_create ? item.date_create_ddmmyy.includes(this.filter) : '') ||
                            (this.columns_date_update ? item.date_update_ddmmyy.includes(this.filter) : '')
                        );
                    });

                    for (let i = 0; i < this.FireStation_Table.length; i++) {
                        this.FireStation_Table[i]['index'] = i + 1;
                    }
                } else {
                    this.FireStation_Table = [...this.cloneTable];
                    for (let i = 0; i < this.FireStation_Table.length; i++) {
                        this.FireStation_Table[i]['index'] = i + 1;
                    }
                }

                // Restore focus to input element after rendering completes
                this.$nextTick(() => {
                    if (this.searchInputRef) {
                        this.searchInputRef.focus();

                        // Place cursor at the end of the text
                        const length = this.searchInputRef.value.length;
                        this.searchInputRef.setSelectionRange(length, length);
                    }
                });
            }, 300); // 300ms delay
        },
        // Doe ค้นหา  3/6 จบ

        async initialData() {
            const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์

            this.ms = true;
            this.filter = '';
            this.cloneTable = [];
            this.loading = true;
            await this.axios
                .post(`${this.$url_service}/initial/firestation`, {
                    body: {
                        topic: 'get-table-firestation',
                        userData: this.getUser(),
                        userOrg
                    }
                })
                // Doe : เพิ่ม ลำดับ 3/4
                .then((response) => {
                    this.FireStation_Table = response.data.data;
                    // console.log(this.FireStation_Table)
                    // Doe ค้นหา  4/6
                    this.cloneTable = response.data.data;
                    // Doe ค้นหา  4/6
                    this.formatData(this.FireStation_Table);
                });
            // Doe : เพิ่ม ลำดับ 3/4 จบ

            if (this.columns_disabled == true) {
                this.FireStation_Table = this.cloneTable;
            } else {
                this.FireStation_Table = [];
            }

            await this.axios
                .post(`${this.$url_service}/general/country`, {
                    body: {
                        topic: 'get-province'
                    }
                })
                .then((response) => {
                    (this.provinceOptions = response.data.data),
                        this.provinceOptions.splice(0, 0, {
                            province_id: 'getall',
                            province_name: this.$i18n.t('selectAll')
                        });
                });

            this.check_Fire_Form_search(this.selectedTambon, this.selectedAmphur, this.selectedProvince, 'search', true);

            await this.axios
                .post(`${this.$url_service}/initial/firestation`, {
                    body: {
                        topic: 'get-option-firestation',
                        userData: this.getUser()
                    }
                })
                .then((response) => {
                    (this.FireStationOptions = response.data.data),
                        this.FireStationOptions.splice(0, 0, {
                            fs_id: 'getall',
                            fs_tname: this.$i18n.t('selectAll')
                        });
                    // console.log("this.FireStationOptions",this.FireStationOptions)
                });
            this.loading = false;
        },
        formatData(data) {
            for (let index = 0; index < data.length; index++) {
                data[index]['index'] = index + 1;

                if (data[index].road_name == null || data[index].road_name == 'null' || data[index].road_name == '') {
                    data[index].road_name = '-';
                }
                if (data[index].soi_name == null || data[index].soi_name == 'null' || data[index].soi_name == '') {
                    data[index].soi_name = '-';
                }
                if (data[index].house_no == null || data[index].house_no == 'null' || data[index].house_no == '') {
                    data[index].house_no = '-';
                }

                if (data[index].event_lat == null || data[index].event_lat == 'null' || data[index].event_lat == '') {
                    data[index].event_lat = '-';
                    data[index]['event_latPDF'] = '-';
                } else if (data[index].event_lat !== '-') {
                    data[index]['event_latPDF'] = parseFloat(data[index].event_lat).toFixed(6);
                }

                if (data[index].event_lon == null || data[index].event_lon == 'null' || data[index].event_lon == '') {
                    data[index].event_lon = '-';
                    data[index]['event_lonPDF'] = '-';
                } else if (data[index].event_lon !== '-') {
                    data[index]['event_lonPDF'] = parseFloat(data[index].event_lon).toFixed(6);
                }

                if (data[index].date_create_ddmmyy == null || data[index].date_create_ddmmyy == 'null' || data[index].date_create_ddmmyy == '') {
                    data[index].date_create_ddmmyy = '-';
                } else {
                    data[index].date_create_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_create_ddmmyy));
                }

                if (data[index].date_update_ddmmyy == null || data[index].date_update_ddmmyy == 'null' || data[index].date_update_ddmmyy == '') {
                    data[index].date_update_ddmmyy = '-';
                } else {
                    data[index].date_update_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_update_ddmmyy));
                }
            }
        },
        closeAllModal() {
            // console.log("Close and don`t save data");
            this.FireStationModal = false;
            this.displayConfirmationCloseModal = false;
            this.clearData();
        },

        someHandler(message) {
            if (message == 'ch-province') {
                this.ira_selectedAmphur = null;
            }
            if (message == 'ch-amphur') {
                this.ira_selectedTambon = null;
            }
        },

        async searchFireStation() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());
            const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์

            this.ms = true;
            // this.filter='';
            this.cloneTable = [];
            this.loading = true;
            // console.log("selectedProvince",this.selectedProvince.province_id)

            await this.axios
                .post(`${this.$url_service}/initial/firestation`, {
                    body: {
                        topic: 'search-table-firestation',
                        userData: this.getUser(),

                        // community_organize:"",
                        fs_tname:
                            this.FireStationSelected == null
                                ? ''
                                : this.FireStationSelected.fs_tname == this.$i18n.t('selectAll')
                                ? ''
                                : this.FireStationSelected.fs_tname,
                        // type:this.type,
                        soi_name: this.soi_name,
                        road_name: this.road_name,
                        // event_detail:this.event_detail,
                        house_no: this.house_no,
                        province: this.selectedProvince,
                        amphur: this.selectedAmphur,
                        tambon: this.selectedTambon,

                        userOrg
                    }
                })
                // Doe : เพิ่ม ลำดับ 4/4
                .then((response) => {
                    this.FireStation_Table = response.data.data;

                    // Doe ค้นหา  5/6
                    this.cloneTable = response.data.data;
                    // Doe ค้นหา  5/6
                    this.formatData(this.FireStation_Table);

                    // this.search()

                    this.setSearchText_Footer();
                });
            // Doe : เพิ่ม ลำดับ 4/4 จบ

            if (this.columns_disabled == true) {
                this.FireStation_Table = this.cloneTable;
            } else {
                this.FireStation_Table = [];
            }

            this.search();
            this.loading = false;
        },
        setSearchText_Footer() {
            this.text_Footer = false;
            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            if (
                this.selectedProvince !== null ||
                this.selectedAmphur !== null ||
                this.selectedTambon !== null ||
                this.FireStationSelected !== null ||
                this.house_no !== '' ||
                this.soi_name !== '' ||
                this.road_name !== ''
            ) {
                for (let index = 0; index < this.Data_text_Footer.length; index++) {
                    const element = this.Data_text_Footer[index];
                    if (element.DataName === 'จังหวัด' && this.selectedProvince !== null) {
                        element.textShow = this.selectedProvince.province_name;
                    }
                    if (element.DataName === 'เขต/อำเภอ' && this.selectedAmphur !== null) {
                        element.textShow = this.selectedAmphur.amphur_name;
                    }
                    if (element.DataName === 'แขวง/ตำบล' && this.selectedTambon !== null) {
                        element.textShow = this.selectedTambon.tambon_name;
                    }
                    if (element.DataName === 'สถานีดับเพลิงและกู้ภัย' && this.FireStationSelected !== null) {
                        element.textShow = this.FireStationSelected.fs_tname;
                    }
                    if (element.DataName === 'เลขที่' && this.house_no !== '') {
                        element.textShow = this.house_no;
                    }
                    if (element.DataName === 'ซอย' && this.soi_name !== '') {
                        element.textShow = this.soi_name;
                    }
                    if (element.DataName === 'ถนน' && this.road_name !== '') {
                        element.textShow = this.road_name;
                    }
                }
                this.text_Footer = true;
            }
        },
        selectMap_passValue(variable) {
            // this.displayMap = false;
            // console.log(variable);
            this.ifh_lat = variable.lat;
            this.ifh_lon = variable.lng;
        },
        selectMap_displayMap() {
            this.displayMap = false;

            // แจ้งเตือนกรณีไม่ได้ ข้อมูลพิกัด
            // console.log("this.ifh_lat",this.ifh_lat)
            // console.log("this.ifh_lon",this.ifh_lon)
            if (this.ifh_lat !== null && this.ifh_lon !== null && this.ifh_lat !== '' && this.ifh_lon !== '') {
                this.$fire({
                    title: 'เพิ่มพิกัดสำเร็จ',
                    // text: "ข้อมูลพิกัด",
                    type: 'success',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
            } else {
                this.$fire({
                    title: 'ยังไม่ได้เลือกข้อมูลพิกัด',
                    // text: "ยังไม่ได้เลือกข้อมูลพิกัด",
                    type: 'warning',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
            }
        },

        //  Doe เพิ่มหมุด map V.2 6/9  -->
        async inputMap_latlon() {
            if (this.ifh_lat !== '' && this.ifh_lat !== null && this.ifh_lon !== '' && this.ifh_lon !== null) {
                await this.axios
                    .get(`https://api.deemap.com/service/geocode/lat=${this.ifh_lat}/lon=${this.ifh_lon}/key=0feb00d7e64c5686bf434b9b90ab2d3c`)
                    .then((response) => {
                        // debugger;
                        if (response.data.data.length > 0) {
                            const data = {
                                ADMIN_CODE: response.data.data[0].ADMIN_CODE,
                                provinceName: response.data.data[0].PROV_TNAME,
                                amphurName: response.data.data[0].AMP_TNAME,
                                tambonName: response.data.data[0].TAM_TNAME,
                                postCODE: response.data.data[0].POSTCOD
                            };
                            const element = data.ADMIN_CODE;
                            const country_ID = `${element[0]}${element[1]}`;
                            const land_ID = `${element[2]}${element[3]}`;
                            const province_ID = `${element[4]}${element[5]}`;
                            const amphur_ID = `${element[4]}${element[5]}${element[6]}${element[7]}`;
                            const tambon_ID = `${element[4]}${element[5]}${element[6]}${element[7]}${element[8]}${element[9]}`;

                            if (country_ID == '66' && land_ID !== '00') {
                                this.ifh_selectedProvince = {
                                    province_name: data.provinceName,
                                    province_id: province_ID
                                };
                                this.ira_selectedAmphur = {
                                    amphur_name: data.amphurName,
                                    amphur_id: amphur_ID
                                };
                                this.ira_selectedTambon = {
                                    tambon_name: data.tambonName,
                                    tambon_id: tambon_ID
                                };

                                this.error_latlon_country = false;
                                this.error_latlon_land = false;

                                this.error_latlon_P = false;
                                this.error_latlon_A = false;
                                this.error_latlon_T = false;
                            } else {
                                if (country_ID !== '66') {
                                    this.error_latlon_country = true;
                                } else {
                                    this.error_latlon_country = false;
                                }
                                if (data.provinceName == null || data.provinceName == 'null' || data.provinceName == '' || data.provinceName == ' ') {
                                    this.error_latlon_P = true;
                                } else {
                                    this.error_latlon_P = false;
                                }
                                if (data.amphurName == null || data.amphurName == 'null' || data.amphurName == '' || data.amphurName == ' ') {
                                    this.error_latlon_A = true;
                                } else {
                                    this.error_latlon_A = false;
                                }
                                if (data.tambonName == null || data.tambonName == 'null' || data.tambonName == '' || data.tambonName == ' ') {
                                    this.error_latlon_T = true;
                                } else {
                                    this.error_latlon_T = false;
                                }
                                this.ifh_selectedProvince = null;
                                this.ira_selectedAmphur = null;
                                this.ira_selectedTambon = null;
                            }

                            // console.log("this.ifh_selectedProvince",this.ifh_selectedProvince)
                            // console.log("this.ira_selectedAmphur",this.ira_selectedAmphur)
                            // console.log("this.ira_selectedTambon",this.ira_selectedTambon)
                        } else {
                            this.ifh_selectedProvince = null;
                            this.ira_selectedAmphur = null;
                            this.ira_selectedTambon = null;

                            this.error_latlon_country = false;
                            this.error_latlon_land = false;

                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        }
                    });
            } else {
                this.ifh_selectedProvince = null;
                this.ira_selectedAmphur = null;
                this.ira_selectedTambon = null;

                this.error_latlon_country = false;
                this.error_latlon_land = false;

                this.error_latlon_P = false;
                this.error_latlon_A = false;
                this.error_latlon_T = false;
            }
        },

        async inputMap_PAT_latlon() {
            // console.log("<<<<<<<<<<<<<<<MMMMMMMMMMMMMM>>>>>>>>>>>>>>>")
            //   console.log("this.ifh_selectedProvince",this.ifh_selectedProvince)
            //   console.log("this.ira_selectedAmphur",this.ira_selectedAmphur)
            //   console.log("this.ira_selectedTambon",this.ira_selectedTambon)

            const url = 'https://service.deemap.com/service/gismis/boundary/geojson';

            let nnP = '';

            if (this.ifh_selectedProvince) {
                this.sP.push(this.ifh_selectedProvince.province_name);
                nnP = this.sP.length - 2;
            }

            let nnA = '';
            if (this.ira_selectedAmphur) {
                this.sA.push(this.ira_selectedAmphur.amphur_name);
                nnA = this.sA.length - 2;
            }

            // if (this.ifh_FireStationSelected) {
            //   await this.axios.post(url,{
            // 				"key":"78e731027d8fd50ed642340b7c9a63b3",
            // 				"topic": "fireStation",
            // 				"type":"point",
            // 				"name":this.ifh_FireStationSelected.fs_tname
            // 			})
            // 			.then((response) => {
            // 				let getData = response.data.data

            // 				const lon = getData.features[0].geometry.coordinates[0];
            // 				const lat = getData.features[0].geometry.coordinates[1];

            //         // const PAT_Tambon = this.ifh_FireStationSelected.tambon_name
            // 				// const PAT_Amphoe = this.ifh_FireStationSelected.amphur_name
            // 				// const PAT_province = this.ifh_FireStationSelected.province_name

            //         // console.log("PAT_Tambon",PAT_Tambon)
            //         // console.log("PAT_Amphoe",PAT_Amphoe)
            //         // console.log("PAT_province",PAT_province)
            //         this.ifh_lat = lat
            //         this.ifh_lon = lon

            //         this.error_latlon_P = false
            //         this.error_latlon_A = false
            //         this.error_latlon_T = false

            // 			})
            // }else
            if (this.ifh_selectedProvince == null) {
                this.ifh_lat = '';
                this.ifh_lon = '';

                this.error_latlon_country = false;
                this.error_latlon_P = false;
                this.error_latlon_A = false;
                this.error_latlon_T = false;
            } else if (this.ira_selectedAmphur == null) {
                await this.axios
                    .post(url, {
                        key: '78e731027d8fd50ed642340b7c9a63b3',
                        topic: 'province',
                        type: 'point',
                        id: this.ifh_selectedProvince.province_id
                    })
                    .then((response) => {
                        let getData = response.data.data;

                        const lon = getData.features[0].geometry.coordinates[0];
                        const lat = getData.features[0].geometry.coordinates[1];

                        this.ifh_lat = lat;
                        this.ifh_lon = lon;

                        this.error_latlon_country = false;
                        this.error_latlon_P = false;
                        this.error_latlon_A = false;
                        this.error_latlon_T = false;
                    });
            } else if (this.sP[nnP] !== this.ifh_selectedProvince.province_name) {
                await this.axios
                    .post(url, {
                        key: '78e731027d8fd50ed642340b7c9a63b3',
                        topic: 'province',
                        type: 'point',
                        id: this.ifh_selectedProvince.province_id
                    })
                    .then((response) => {
                        let getData = response.data.data;

                        const lon = getData.features[0].geometry.coordinates[0];
                        const lat = getData.features[0].geometry.coordinates[1];

                        this.ifh_lat = lat;
                        this.ifh_lon = lon;

                        this.error_latlon_country = false;
                        this.error_latlon_P = false;
                        this.error_latlon_A = false;
                        this.error_latlon_T = false;
                    });
            } else if (this.sA[nnA] !== this.ira_selectedAmphur.amphur_name) {
                await this.axios
                    .post(url, {
                        key: '78e731027d8fd50ed642340b7c9a63b3',
                        topic: 'amphoe',
                        type: 'point',
                        id: this.ira_selectedAmphur.amphur_id
                    })
                    .then((response) => {
                        let getData = response.data.data;

                        const lon = getData.features[0].geometry.coordinates[0];
                        const lat = getData.features[0].geometry.coordinates[1];

                        this.ifh_lat = lat;
                        this.ifh_lon = lon;

                        this.error_latlon_country = false;
                        this.error_latlon_P = false;
                        this.error_latlon_A = false;
                        this.error_latlon_T = false;
                    });
            } else {
                // if (this.ifh_FireStationSelected) {
                // 	await this.axios.post(url,{
                // 			"key":"78e731027d8fd50ed642340b7c9a63b3",
                // 			"topic": "fireStation",
                // 			"type":"point",
                // 			"name":this.ifh_FireStationSelected.fs_tname
                // 		})
                // 		.then((response) => {
                // 			let getData = response.data.data

                // 			const lon = getData.features[0].geometry.coordinates[0];
                // 			const lat = getData.features[0].geometry.coordinates[1];

                //       this.ifh_lat = lat
                //       this.ifh_lon = lon

                //       this.error_latlon_P = false
                //       this.error_latlon_A = false
                //       this.error_latlon_T = false

                // 		})
                // }else
                if (this.ira_selectedTambon) {
                    await this.axios
                        .post(url, {
                            key: '78e731027d8fd50ed642340b7c9a63b3',
                            topic: 'tambon',
                            type: 'point',
                            id: this.ira_selectedTambon.tambon_id
                        })
                        .then((response) => {
                            let getData = response.data.data;

                            const lon = getData.features[0].geometry.coordinates[0];
                            const lat = getData.features[0].geometry.coordinates[1];

                            this.ifh_lat = lat;
                            this.ifh_lon = lon;

                            this.error_latlon_country = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        });
                } else if (this.ira_selectedAmphur) {
                    await this.axios
                        .post(url, {
                            key: '78e731027d8fd50ed642340b7c9a63b3',
                            topic: 'amphoe',
                            type: 'point',
                            id: this.ira_selectedAmphur.amphur_id
                        })
                        .then((response) => {
                            let getData = response.data.data;

                            const lon = getData.features[0].geometry.coordinates[0];
                            const lat = getData.features[0].geometry.coordinates[1];

                            this.ifh_lat = lat;
                            this.ifh_lon = lon;

                            this.error_latlon_country = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        });
                } else if (this.ifh_selectedProvince) {
                    await this.axios
                        .post(url, {
                            key: '78e731027d8fd50ed642340b7c9a63b3',
                            topic: 'province',
                            type: 'point',
                            id: this.ifh_selectedProvince.province_id
                        })
                        .then((response) => {
                            let getData = response.data.data;

                            const lon = getData.features[0].geometry.coordinates[0];
                            const lat = getData.features[0].geometry.coordinates[1];

                            this.ifh_lat = lat;
                            this.ifh_lon = lon;

                            this.error_latlon_country = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        });
                } else {
                    this.ifh_lat = '';
                    this.ifh_lon = '';
                }
            }
        },
        //  Doe เพิ่มหมุด map V.2 6/9  จบ-->

        async confirmDelete() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            const userOrg = this.getUserOrganize(); //เช็คสิทธิ์
            const userId = this.getUsername();

            this.displayConfirmation = false;
            await this.axios
                .post(`${this.$url_service}/initial/firestation?user=${userId}`, {
                    body: {
                        topic: 'delete-firestation',
                        userData: this.getUser(),
                        id: this.temp
                    }
                })
                .then(() =>
                    // this.initialData()
                    this.searchFireStation()
                );
            this.$fire({
                type: 'success',
                title: 'ลบข้อมูลสำเร็จ',
                text: 'ข้อมูลสถานีดับเพลิงและกู้ภัย',
                timer: 3000,
                confirmButtonColor: '#28B463'
            });
        },

        async saveData() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            //ตัวแดงทั้งหมด
            if (
                this.ifs_FireStation == '' ||
                this.ifh_selectedProvince == null ||
                this.ira_selectedAmphur == null ||
                this.ira_selectedTambon == null ||
                this.ifh_lat == '' ||
                this.ifh_lon == ''
            ) {
                if (this.ifs_FireStation == '') {
                    this.error_ifs_FireStation = true;
                }
                if (this.ifh_selectedProvince == null) {
                    this.error_ifh_selectedProvince = true;
                }
                if (this.ira_selectedAmphur == null) {
                    this.error_ira_selectedAmphur = true;
                }
                if (this.ira_selectedTambon == null) {
                    this.error_ira_selectedTambon = true;
                }
                if (this.ifh_lon == '') {
                    this.error_ifh_lon = true;
                }
                if (this.ifh_lat == '') {
                    this.error_ifh_lat = true;
                }
            } else {
                if (this.selectedData == '') {
                    // console.log('this.selectedData =', this.selectedData);
                    // โหลดเพิ่มแก้ไข 4/8
                    this.loadingCreate = true;
                    // โหลดเพิ่มแก้ไข 4/8 จบ

                    const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์
                    const userId = this.getUsername();
                    await this.axios
                        .post(`${this.$url_service}/initial/firestation?user=${userId}`, {
                            body: {
                                topic: 'add-firestation',
                                userOrg,
                                userData: this.getUser(),
                                fs_tname: this.ifs_FireStation,
                                soi_name: this.icommu_soi_name,
                                road_name: this.icommu_road_name,
                                house_no: this.ifs_house_no,
                                // event_detail:this.ifs_event_detail,
                                location_id: this.ira_selectedTambon,
                                lat: this.ifh_lat,
                                lon: this.ifh_lon
                            }
                        })
                        .then((response) => {
                            (this.check_duplicate = response.data.message),
                                // (this.initialData());
                                this.searchFireStation();
                        });
                    // โหลดเพิ่มแก้ไข 5/8
                    this.loadingCreate = false;
                    // โหลดเพิ่มแก้ไข 5/8 จบ
                    this.tempFor_displayConfirmationCloseModal = 'add';
                    this.FireStationModal = false;
                    this.$fire({
                        type: 'success',
                        title: 'เพิ่มข้อมูลสำเร็จ',
                        text: 'ข้อมูลสถานีดับเพลิงและกู้ภัย',
                        timer: 3000,
                        confirmButtonColor: '#28B463'
                    });
                } else {
                    // โหลดเพิ่มแก้ไข 6/8 จบ
                    this.loadingCreate = true;
                    // โหลดเพิ่มแก้ไข 6/8 จบ

                    // console.log("this.ifs_FireStation",this.ifs_FireStation)

                    const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์
                    const userId = this.getUsername();
                    await this.axios
                        .post(`${this.$url_service}/initial/firestation?user=${userId}`, {
                            body: {
                                topic: 'edit-firestation',
                                id: this.temp,
                                userData: this.getUser(),
                                userOrg,
                                fs_tname: this.ifs_FireStation,
                                soi_name: this.icommu_soi_name,
                                road_name: this.icommu_road_name,
                                house_no: this.ifs_house_no,
                                // event_detail:this.ifs_event_detail,
                                location_id: this.ira_selectedTambon,
                                lat: this.ifh_lat,
                                lon: this.ifh_lon
                            }
                        })
                        .then(() =>
                            // this.initialData()
                            this.searchFireStation()
                        );
                    // โหลดเพิ่มแก้ไข 7/8 จบ
                    this.loadingCreate = false;
                    // โหลดเพิ่มแก้ไข 7/8 จบ

                    this.$fire({
                        type: 'success',
                        title: 'แก้ไขข้อมูลสำเร็จ',
                        text: 'ข้อมูลสถานีดับเพลิงและกู้ภัย',
                        timer: 3000,
                        confirmButtonColor: '#28B463'
                    });
                    // console.log("Edit data");
                    this.FireStationModal = false;
                }
            }
        },

        async editData(data) {
            if (!this.checkToken()) {
                return;
            }

            function toThaiDateFormat(dateString) {
                try {
                    // Split the date string by '/'
                    const [day, month, year] = dateString.split('/');

                    // Create a date object (months in JavaScript are 0-based, so subtract 1 from month)
                    const date = new Date(year, month - 1, day);

                    // Check if date is valid
                    if (isNaN(date.getTime())) {
                        return '-';
                    }

                    // Format options
                    const options = {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                    };

                    // Convert to Thai date
                    return date.toLocaleDateString('th-TH', options);
                } catch (error) {
                    return '-';
                }
            }

            // console.log('this.checkToken() = ', this.checkToken());

            // console.log('data =', data);
            this.header_FireStation = this.$i18n.t('ifs_modal_title_edit');
            await this.axios
                .post(`${this.$url_service}/initial/firestation`, {
                    body: {
                        topic: 'showone-firestation',
                        userData: this.getUser(),
                        id: data
                    }
                })
                .then((response) => {
                    // console.log("response.data.data",response.data.data)
                    // console.log("response.data.data",response.data.data.fire_station)
                    this.selectedData = response.data.data;
                    // console.log("this.selectedData",this.selectedData)
                    // this.ifs_event_detail = response.data.data.event_detail
                    this.ifs_house_no = response.data.data.house_no;
                    this.icommu_soi_name = response.data.data.soi_name;
                    this.icommu_road_name = response.data.data.road_name;
                    this.ifh_selectedProvince = response.data.data.province_name;
                    this.ira_selectedAmphur = response.data.data.amphur_name;
                    this.ira_selectedTambon = response.data.data.tambon_name;
                    // this.icommu_type = response.data.data.type

                    this.ifh_lat = response.data.data.event_lat;
                    this.ifh_lon = response.data.data.event_lon;
                    this.ifs_FireStation = response.data.data.fs_tname;

                    this.date_create_form =
                        toThaiDateFormat(response.data.data.date_create_ddmmyy) == null
                            ? '-'
                            : toThaiDateFormat(response.data.data.date_create_ddmmyy);
                    this.date_update_form =
                        toThaiDateFormat(response.data.data.date_update_ddmmyy) == null
                            ? '-'
                            : toThaiDateFormat(response.data.data.date_update_ddmmyy);

                    // Doe เพิ่มหมุด map V.2 7/9
                    if (this.ifh_lat !== '' && this.ifh_lat !== null && this.ifh_lon !== '' && this.ifh_lon !== null) {
                        this.inputMap_latlon();
                    } else {
                        this.inputMap_PAT_latlon();
                    }
                    // Doe เพิ่มหมุด map V.2 7/9  จบ
                });
        },

        clearData() {
            this.dropdownClearFilerValue += 1;
            //Edit data
            if (this.selectedData != '') {
                this.header_FireStation = this.$i18n.t('ifs_modal_title_add');
                this.temp = null;
                this.displayConfirmation = false;
                this.selectedData = '';
                this.FireStationModal = false;
                this.setDefault();
                //Add data
            } else {
                this.temp = null;
                this.displayConfirmation = false;
                this.setDefault();
            }
        },

        setDefault() {
            this.tempFor_displayConfirmationCloseModal = '';
            this.icommu_soi_name = '';
            this.icommu_road_name = '';

            this.ifh_lat = '';
            this.ifh_lon = '';
            this.error_ifh_lat = false;
            this.error_ifh_lon = false;
            this.ifh_selectedProvince = null;
            this.error_ifh_selectedProvince = false;
            this.error_ira_selectedAmphur = false;
            this.error_ira_selectedTambon = false;
            this.ifh_FireStationSelected = null;
            this.error_ifh_FireStationSelected = false;

            this.ifs_house_no = '';
            this.ifs_FireStation = '';
            this.error_ifs_FireStation = false;

            this.error_latlon_country = false;
            this.error_latlon_land = false;
            this.error_latlon_P = false;
            this.error_latlon_A = false;
            this.error_latlon_T = false;

            this.date_create_form = '';
            this.date_update_form = '';
        },

        async clearSearchField() {
            this.selectedProvince = null;
            this.FireStationSelected = null;
            this.house_no = '';
            this.soi_name = '';
            this.road_name = '';

            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            this.text_Footer = false;

            this.dropdownClearFilerValue += 1;
            // Doe ค้นหา
            this.filter = '';
            this.cloneTable = [];
            this.initialData();
        },
        // Doe โหลด โทรศัพท์
        async MobileClearSearchField() {
            // console.log("this.ms3333",this.ms)
            if (this.ms == true) {
                this.clearSearchField();
            } else {
                // console.log("25")
                this.selectedProvince = null;
                this.FireStationSelected = null;
                this.soi_name = '';
                this.road_name = '';

                this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
                this.text_Footer = false;

                this.dropdownClearFilerValue += 1;
                this.house_no = '';
                this.filter = '';
                this.cloneTable = [];
            }
        },
        // Doe โหลด โทรศัพท์
        // Doe :   เพิ่ม มุดmap 4/4
        sendM(ifh_lat, ifh_lon) {
            let lat = ifh_lat;
            let lon = ifh_lon;
            this.latlon = { lat, lon };
            // console.log("send ",this.latlon)
        },
        sendM_PAT(tambon, amphur, province, FireStationSelected) {
            if (FireStationSelected) {
                this.FSS = FireStationSelected;
            } else {
                this.FSS = {};
            }

            if (tambon) {
                this.PAT = tambon;
            } else if (amphur) {
                this.PAT = amphur;
            } else if (province) {
                this.PAT = province;
            } else {
                this.PAT = {};
            }
        },

        //  Doe เพิ่มหมุด map V.2 8/9  -->
        receiveM_PAT(data) {
            // console.log("data",data)
            const element = data.ADMIN_CODE;
            const country_ID = `${element[0]}${element[1]}`;
            const land_ID = `${element[2]}${element[3]}`;
            const province_ID = `${element[4]}${element[5]}`;
            const amphur_ID = `${element[4]}${element[5]}${element[6]}${element[7]}`;
            const tambon_ID = `${element[4]}${element[5]}${element[6]}${element[7]}${element[8]}${element[9]}`;

            if (country_ID == '66' && land_ID !== '00') {
                this.ifh_selectedProvince = {
                    province_name: data.provinceName,
                    province_id: province_ID
                };
                this.ira_selectedAmphur = {
                    amphur_name: data.amphurName,
                    amphur_id: amphur_ID
                };
                this.ira_selectedTambon = {
                    tambon_name: data.tambonName,
                    tambon_id: tambon_ID
                };

                this.error_latlon_country = false;
                this.error_latlon_land = false;

                this.error_latlon_P = false;
                this.error_latlon_A = false;
                this.error_latlon_T = false;
            } else {
                if (country_ID !== '66') {
                    this.error_latlon_country = true;
                } else {
                    this.error_latlon_country = false;
                }
                // if(land_ID == "00"){
                //   this.error_latlon_land = true
                // }else{
                //   this.error_latlon_land = false
                // }

                if (data.provinceName == null || data.provinceName == 'null' || data.provinceName == '' || data.provinceName == ' ') {
                    this.error_latlon_P = true;
                } else {
                    this.error_latlon_P = false;
                }
                if (data.amphurName == null || data.amphurName == 'null' || data.amphurName == '' || data.amphurName == ' ') {
                    this.error_latlon_A = true;
                } else {
                    this.error_latlon_A = false;
                }
                if (data.tambonName == null || data.tambonName == 'null' || data.tambonName == '' || data.tambonName == ' ') {
                    this.error_latlon_T = true;
                } else {
                    this.error_latlon_T = false;
                }

                this.ifh_selectedProvince = null;
                this.ira_selectedAmphur = null;
                this.ira_selectedTambon = null;
            }

            // console.log("receiveM_PAT-------------------")
            // console.log("country_ID",country_ID)
            // console.log("land_ID",land_ID)
            // console.log("this.ifh_selectedProvince",this.ifh_selectedProvince)
            // console.log("this.ira_selectedAmphur",this.ira_selectedAmphur)
            // console.log("this.ira_selectedTambon",this.ira_selectedTambon)
        },
        //  Doe เพิ่มหมุด map V.2 8/9  จบ-->

        // Doe :   เพิ่ม มุดmap 4/4 จบ
        alertDisplay(temp) {
            this.$fire({
                title: 'ยืนยันการลบข้อมูล',
                text: 'คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?',

                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
            }).then((result) => {
                // console.log(temp)
                if (result.value) {
                    // console.log(temp)
                    this.confirmDelete(temp);
                }
            });
        },

        // Doe PDF เลือกได้  5/5
        EditPDF() {
            this.displayEditPDF = true;
            this.columnsSelectorDialog = this.columnsSelector;
        },
        SaveEditPDF() {
            if (this.columnsSelectorDialog.length <= 4) {
                this.PDF_minCellWidthVer = 120;
                this.PDF_FontHeaderVer = 13;
                this.PDF_FontBodyVer = 11;

                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 35 }
                };

                this.PDF_minCellWidthHor = 120;
                this.PDF_FontHeaderHor = 15;
                this.PDF_FontBodyHor = 12;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 35 }
                };
            } else if (this.columnsSelectorDialog.length <= 6) {
                this.PDF_minCellWidthVer = 50;
                this.PDF_FontHeaderVer = 13;
                this.PDF_FontBodyVer = 11;

                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 35 }
                };

                this.PDF_minCellWidthHor = 80;
                this.PDF_FontHeaderHor = 15;
                this.PDF_FontBodyHor = 12;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 35 }
                };
            } else {
                this.PDF_minCellWidthVer = 40;
                this.PDF_FontHeaderVer = 9;
                this.PDF_FontBodyVer = 7;
                this.PDF_BodySizeSelect = this.PDF_BodySize;

                this.PDF_minCellWidthHor = 50;
                this.PDF_FontHeaderHor = 12;
                this.PDF_FontBodyHor = 10;

                this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;
            }

            if (this.columnsSelectorDialog.length == 0) {
                this.columns_index = false;
                this.columns_fs_tname = false;
                this.columns_house_no = false;
                this.columns_soi_name = false;
                this.columns_road_name = false;
                this.columns_tambon_name = false;
                this.columns_amphur_name = false;
                this.columns_province_name = false;
                this.columns_event_lat = false;
                this.columns_event_lon = false;

                this.columns_date_create = false;
                this.columns_date_update = false;

                this.columns_disabled = false;
            } else {
                this.columns_disabled = true;
                // console.log('this.columnsSelectorDialog =', this.columnsSelectorDialog);

                let getData = [];

                // ! จัดข้อมูล
                for (let index = 0; index < this.columnsSelectorDialog.length; index++) {
                    getData.push(this.columnsSelectorDialog[index].dataKey);
                }
                // console.log("getData",getData);

                // ! เช็คข้อมูล

                for (let index = 0; index < this.columnsSelectorDialog.length; index++) {
                    const element = this.columnsSelectorDialog[index].dataKey;

                    if (element == 'index') {
                        this.columns_index = true;
                    } else if (!getData.includes('index')) {
                        // console.log("getData.includes(index)",getData.includes("index"))
                        this.columns_index = false;
                    }

                    if (element == 'fs_tname') {
                        this.columns_fs_tname = true;
                    } else if (!getData.includes('fs_tname')) {
                        this.columns_fs_tname = false;
                    }

                    if (element == 'house_no') {
                        this.columns_house_no = true;
                    } else if (!getData.includes('house_no')) {
                        this.columns_house_no = false;
                    }

                    if (element == 'soi_name') {
                        this.columns_soi_name = true;
                    } else if (!getData.includes('soi_name')) {
                        this.columns_soi_name = false;
                    }

                    if (element == 'road_name') {
                        this.columns_road_name = true;
                    } else if (!getData.includes('road_name')) {
                        this.columns_road_name = false;
                    }

                    if (element == 'tambon_name') {
                        this.columns_tambon_name = true;
                    } else if (!getData.includes('tambon_name')) {
                        this.columns_tambon_name = false;
                    }

                    if (element == 'amphur_name') {
                        this.columns_amphur_name = true;
                    } else if (!getData.includes('amphur_name')) {
                        this.columns_amphur_name = false;
                    }

                    if (element == 'province_name') {
                        this.columns_province_name = true;
                    } else if (!getData.includes('province_name')) {
                        this.columns_province_name = false;
                    }

                    // if (element == "event_lat") {
                    //   this.columns_event_lat = true
                    // }else if(!getData.includes("event_lat")){

                    //   this.columns_event_lat = false
                    // }

                    // if (element == "event_lon") {
                    //   this.columns_event_lon = true
                    // }else if(!getData.includes("event_lon")){

                    //   this.columns_event_lon = false
                    // }

                    if (element == 'event_latPDF') {
                        this.columns_event_lat = true;
                    } else if (!getData.includes('event_latPDF')) {
                        this.columns_event_lat = false;
                    }

                    if (element == 'event_lonPDF') {
                        this.columns_event_lon = true;
                    } else if (!getData.includes('event_lonPDF')) {
                        this.columns_event_lon = false;
                    }

                    if (element == 'date_create_ddmmyy') {
                        this.columns_date_create = true;
                    } else if (!getData.includes('date_create_ddmmyy')) {
                        this.columns_date_create = false;
                    }

                    if (element == 'date_update_ddmmyy') {
                        this.columns_date_update = true;
                    } else if (!getData.includes('date_update_ddmmyy')) {
                        this.columns_date_update = false;
                    }
                }
            }

            this.columnsSelector = this.columnsSelectorDialog;
            this.displayEditPDF = false;
            this.filter = '';
        },
        CloseEditPDF() {
            this.displayEditPDF = false;
        },
        ClearEditPDF() {
            this.columnsSelectorDialog = [];
        },
        SelectAllEditPDF() {
            this.columnsSelectorDialog = this.columns;
        }
        // Doe PDF เลือกได้  5/5 จบ
    }
};
</script>

<style scoped>
/*   Doe เพิ่มหมุด map V.2 9/9  --> */
.warningLATLON {
    color: rgb(225, 144, 13);
    font-size: 0.9rem;
}
/*   Doe เพิ่มหมุด map V.2 9/9  จบ--> */
.table_row {
    text-align: center;
}

@media screen and (min-width: 819px) and (max-width: 1200px) {
    #Search {
        width: 20rem;
    }
}
/* @media screen and (min-width: 538px){
        #Create{
        width: 146px;
      }
     
  } */
#text_Foote {
    font-size: 1.2rem;
}
#Create {
    width: 149px;
}
#EX {
    width: 149px;
}
#PDF {
    width: 149px;
}
#TABLE_EDIT {
    width: 149px;
}
@media screen and (max-width: 818px) {
    #Search {
        width: 100%;
    }
}

@media screen and (max-width: 430px) {
    #Create {
        width: 50%;
    }
    #EX {
        width: 50%;
    }
    #PDF {
        width: 55%;
    }
    #TABLE_EDIT {
        width: 45%;
    }
    .EV_disasterOptions {
        width: 16.75rem;
        overflow-y: scroll;
    }
    .EV_disasterOptions::-webkit-scrollbar {
        width: 0;
        height: 1px;
    }

    .EV_disasterOptions::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    }

    .EV_disasterOptions::-webkit-scrollbar-thumb {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
    }
}

.p-field {
    margin-bottom: 0rem;
}
</style>

<style>
@keyframes p-progress-spinner-color {
    100%,
    0% {
        stroke: #75e9f4;
    }
    40% {
        stroke: #0057e7;
    }
    66% {
        stroke: #75e9f4;
    }
    80%,
    90% {
        stroke: #0057e7;
    }
}
.p-datatable-thead {
    border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
    border: 2px solid #d6d6d6;
}
</style>

<style scoped lang="scss">
:deep(.p-datatable-wrapper table) {
    border-left: 1px solid #d6d4d4;
    border-right: 1px solid #d6d4d4;
    border-collapse: separate;
    border-spacing: 0;
}
:deep(.p-datatable-scrollable-header-table) {
    background-color: #d6d4d4;
}
:deep(.p-datatable-wrapper) {
    max-height: 550px;
    overflow: auto;
}

:deep(.p-dialog) {
    @media screen and (max-width: 991px) {
        .p-dialog-content {
            overflow-y: auto;
        }
    }
}

.p-multiselect {
    min-width: 15rem;
}

.multiselect-custom {
    // Doe PDF เลือกได้
    width: 100%;
    .p-multiselect-label:not(.p-placeholder) {
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
    }

    .item {
        display: flex;
        align-items: center;
    }

    .item-value {
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 3px;
        display: inline-flex;
        margin-right: 0.5rem;
        background-color: var(--primary-color);
        color: var(--primary-color-text);
    }
}
</style>
